<template>
  <div>
  <b-modal ref="pres-modal" :visible="open && !prescriptionMinimized" size="xl" scrollable no-close-on-backdrop hide-header-close
    @hide="handleModalHide">
    <template v-slot:modal-title>
      <b-row align-h="between" class="head-container">
        <b-col md="4" align-self="center">
          <b-row>
            <b-col md="10">
              <h5>{{ $t('visit.addPrescription') }}</h5>
            </b-col>
            <b-col class="pr-0 head-arrows">
              <p class="text-right h4">
                <b-icon class="cursor-point" icon="arrow-right-circle-fill" v-if="blockFullView" variant="secondary"
                  @click="toggleSidebar"></b-icon>
                <b-icon class="cursor-point" icon="arrow-left-circle-fill" v-if="!blockFullView" variant="secondary"
                  @click="toggleSidebar"></b-icon>
              </p>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="8" class="text-right">
          <b-row align-v="center" class="flex-nowrap">
            <b-col cols="auto" class="custom-check">
              <b-form-checkbox v-model="withPayment" @change="changePayment"
                :style="{ color: patient.ewus === 1 ? 'green' : 'red' }">
                {{ $t('visit.onlyRefunded') }}
              </b-form-checkbox>
            </b-col>
            <b-col class="flex-grow-1 min-width-0">
              <vue-tags-input v-model="tag" v-on:ready="childReady = true" ref="tagInput"
                :autocomplete-items="autocompleteItems" :placeholder="placeholderText"
                :add-only-from-autocomplete="true" @before-adding-tag="checkTag">
                <div slot="autocomplete-item" slot-scope="props" class="my-item">
                  <b-card no-body v-if="props.item.n !== 0">
                    <b-card-header header-tag="header" class="p-1 med-search-header" role="tab" style="text-align: left"
                      :class="{ 'type2': props.item.groupType == 2 }">
                      <b-row>
                        <b-col md="12" class="pl-3" style="cursor: pointer" @click="przelaczGrupe(props.item.id)">
                          <span class="plus-icon" v-if="otwartaGrupa !== props.item.id">+ </span>
                          <span class="minus-icon" v-else>- </span>
                          <span class="pl-2 mr-2">{{ props.item.text }} <span class="text-info pl-0">({{ props.item.n }} leków)</span></span>
                          <span>
                            <b-button variant="primary" class="m-0" size="sm"
                              v-if="props.item.n === 1"
                              @click.stop="addMedicineToPres(lekiWidoczne[props.item.id][0])" style="font-size:11px">
                              {{ $t('visit.addThisBtn') }}
                            </b-button>
                          </span>
                        </b-col>
                      </b-row>
                    </b-card-header>
                    <!-- podpowiedzi = lekkie nagłówki; leki w lekiWidoczne i rysowane tylko w otwartej grupie
                         (vue-tags-input klonuje JSON-em każdą podpowiedź przy każdej literze — z lekami w środku karta zamarzała) -->
                    <div role="tabpanel" v-if="otwartaGrupa === props.item.id">
                      <b-card-body>
                        <b-card-text>
                          <b-row align-v="center" v-for="(item, index) in lekiWidoczne[props.item.id]"
                            :key="'search' + index" class="med-row">
                            <b-col class="pl-2 p-0">
                              <!-- @click="props.performAdd(item)" -->
                              <span class="d-inline-block p-1 pl-3 pr-2 mr-2" @click="addMedicineToPres(item)">{{
                                item.medicineName.replace(item.strength, '') }} - {{ item.strength }} | {{
                                  opakowanie(item)
                                }} <span class="block"> R: {{ item._ref }}</span>
                                <span v-if="item.price" class="sub-text p-0"><br /> {{ $t('visit.price') }}: {{ item.price }}</span>
                                <br />
                                <div class="sub-text comp p-0"><u>{{ $t('visit.composition') }}:</u></div>
                                <template v-if="item.activeSubstances.length > 0">
                                  {{ item._meds.perUnit }}
                                  <div class="sub-text p-0" v-for="(compItem, compIndex) in item._meds.comps"
                                    :key="'comp' + compIndex">{{
                                      compItem.composition }}
                                  </div>
                                </template>
                                <!-- <div class="sub-text p-0" v-for="(compItem, compIndex) in item.activeSubstances"
                                  :key="'comp' + compIndex">{{
                                    compItem.name }} - {{ item.strength }}
                                    {{ parseMedsData({substances:compItem.name,strengths:item.strength }) }}
                                    </div> -->

                              </span>
                            </b-col>
                            <b-col md="3" class="text-left pl-2 med-actions">
                              <b-button variant="transparent" class="p-0" style="vertical-align:top;margin-top:0px;"
                                @click="showMedInfo(item)">
                                <span class="custom-icon">i</span>
                                <!-- <b-icon icon="info-circle-fill" scale="1" variant="info" class="med-info"
                                  @click="showMedInfo(item)"></b-icon> -->
                              </b-button>
                              <b-button variant="transparent" class="p-0" style="vertical-align:top;margin-top:0px;"
                                @click="addMedicineToPres(item)">
                                <span class="custom-icon"> &#43;</span>
                                <!-- <b-icon icon="plus-circle-fill" scale="1" variant="info"
                                  @click="addMedicineToPres(item)"></b-icon> -->
                              </b-button>
                              <b-button variant="transparent" class="p-0" style="vertical-align:top;margin-top:0px;"
                                @click="addToDoctorFavourites(item)">
                                <span class="custom-icon star"> &#9733;</span>
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-card-text>
                      </b-card-body>
                    </div>
                  </b-card>
                </div>
              </vue-tags-input>
              <div v-if="tag !== ''" :class="`${medResultSuccess ? 'green circle' : 'circle orange pulse'}`"></div>
            </b-col>
            <b-col cols="auto" class="prescription-header-actions">
              <button type="button" class="header-action-btn minimize-btn" :title="$t('visit.minimizeTooltip')"
                :aria-label="$t('visit.minimizeTooltip')" @click.stop="minimizePrescription">
                <b-icon icon="dash-square"></b-icon>
              </button>
              <button type="button" class="header-action-btn close-btn" :title="$t('close')" :aria-label="$t('close')"
                @click.stop="attemptClosePrescription">
                <b-icon icon="x"></b-icon>
              </button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </template>
    <div class="trans-container">
      <b-row class="ml-2 mr-2">
        <b-col md="12" sm="12"> </b-col>
        <!-- first block -->
        <b-col :md="firstBlockSize" sm="12" class="trans-first-block pl-0">
          <div class="info-box" v-if="showInfo">
            <div class="info-header p-2 pr-1">
              <b-row class="pr-2" align-h="between">
                <b-col>
                  <h6>{{ $t('visit.infoPopUpDetails.infoPopupTitle') }}</h6>
                </b-col>
                <b-col cols="2" class="text-right">
                  <b-icon icon="x" scale="1.5" variant="secondary" style="cursor: pointer" @click="closeInfo"></b-icon>
                </b-col>
              </b-row>
            </div>
            <div class="p-3 med-description" v-bind:class="[
              Object.keys(medInfo).length === 0 ? 'hide-info' : 'show-info'
            ]">
              <b-row>
                <b-col md="12">
                  <b>{{ medInfo.medicineName }}</b>,
                  <span class="content-block">{{ medInfo.manufacturer }}</span>
                  <div>
                    <span class="title">{{ $t('visit.infoPopUpDetails.dose') }}: </span>
                    <span class="content-block">{{ medInfo.strength }}</span>
                  </div>
                  <div>
                    <span class="title">{{ $t('visit.infoPopUpDetails.package') }}: </span>
                    <span class="content-block">{{ medInfo.packageSize }} tablets</span>
                  </div>
                  <div>
                    <span class="title">{{ $t('visit.infoPopUpDetails.price') }}: PLN</span>
                    <span class="content-block">{{ medInfo.price }}</span>
                  </div>
                  <div><span class="title">{{ $t('visit.infoPopUpDetails.availableRefunds') }}</span></div>
                  <ul>
                    <li class="content-block" v-for="(item, index) in medInfo.taksacja" :key="'desc' + index">
                      <div v-if="Object.keys(item).includes('description')">
                        {{ item.refundation }} - {{ item.description }}
                      </div>
                      <div v-else>{{ item.refundation }}</div>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </div>
          </div>
          <b-row :class="{ 'hide-block': firstBlockSize == 0 }">
            <b-col md="12" sm="12">
              <b-row if="patient">
                <b-col cols="12">
                  <table class="prescription-table">
                    <tr>
                      <td class="sub-head">{{ $t('visit.addPatient') }}</td>
                      <td>
                        {{ patient.firstName }}
                        {{ patient.lastName }}
                      </td>
                    </tr>
                    <tr>
                      <td class="sub-head">PESEL</td>
                      <td>{{ patient.pesel }}</td>
                    </tr>
                    <tr>
                      <td class="sub-head">{{ $t('visit.address') }}</td>
                      <td>
                        {{ patient.address }}
                        <br />
                        {{ patient.city }},
                      </td>
                    </tr>
                    <tr>
                      <td>Teryt:</td>
                      <td>
                        <span v-if="patient.teryt">{{ patient.teryt }}</span><b-form-input v-model="prescription.teryt"
                          :state="prescription.teryt" v-else />
                      </td>
                    </tr>

                    <tr>
                      <td class="sub-head">{{ $t('visit.isInsuranced') }}?</td>
                      <td :style="{ color: patient.ewus === 1 ? 'green' : 'red' }">
                        {{ patient.ewus === 1 ? 'Tak' : 'Nie' }}
                      </td>
                    </tr>
                  </table>
                </b-col>
              </b-row>
            </b-col>

            <b-col md="12" sm="12" class="mt-4">
              <h6 class="sub-head">
                {{ $t('visit.patientPastPrescription') }}
              </h6>
              <h5>
                <b-button v-if="prevMedicines.length !== 0 && selectedMedicines.length !== 0" variant="secondary"
                  @click="includeSelectedMedToPres()">{{ $t('visit.addSelectedMedicines') }}</b-button>
              </h5>
              <div v-if="prevMedicines.length === 0" class="pt-2">
                <b-alert show variant="secondary">{{
                  $t('visit.noPastPrescriptions')
                  }}</b-alert>
              </div>
              <div class="accordion mb-1 mt-4" role="tablist" v-if="prevMedicines">
                <b-card no-body v-for="(item, index) in prevMedicines" :key="'prev' + index">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-row class="p-0" v-b-toggle="'prev-med-' + index">
                      <b-col md="9" class="text-left">
                        <b-button class="small text-left" variant="transparent"><span class="text-info pl-0">({{
                          item.medicines.length }} leków)</span> -
                          {{ item.date | formatDate }}</b-button>

                      </b-col>
                      <b-col class="text-right">
                        <b-button variant="transparent" @click="reuseMedicine(item.medicines)">
                          <font-awesome-icon icon="redo"></font-awesome-icon>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-card-header>
                  <b-collapse :id="'prev-med-' + index" role="tabpanel">
                    <b-card-body>
                      <b> PIN : <span>{{ item.ww_pin }}</span> </b>
                      <b-card-text>
                        <b-form-group label="" v-slot="{ ariaDescribedby }">
                          <!-- {{ selectedMedicines }} -->
                          <!-- {{ item.medicines }} -->
                          <b-form-checkbox-group v-model="selectedMedicines" :options="item.medicines"
                            value-field="keyValue" text-field="displayText" :aria-describedby="ariaDescribedby"
                            name="flavour-2a" stacked></b-form-checkbox-group>
                        </b-form-group>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col :md="secondBlockSize" sm="12" class="pl-3 pr-0">
          <div>
            <b-row align-v="center" align="right">
              <b-col md="7" sm="12" align-v="center" class="switch-control">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group v-model="selectedFav" :options="favOptions" @change="changeFavourites($event)"
                    :aria-describedby="ariaDescribedby" switches></b-form-checkbox-group>
                </b-form-group>
              </b-col>
              <b-col md="5" sm="12">
                <!-- <h6 class="sub-head" v-if="selectedFav[selectedFav.length-1] == 'doctorFav'">Doctor Favourites</h6> -->
                <b-input-group size="sm" v-if="selectedFav[selectedFav.length - 1] == 'doctorFav'">
                  <multiselect class="vue-multiselect" :show-labels="false" v-model="selectedDoctorFav"
                    :placeholder="$t('visit.selectMedicine')" :options="doctorFavOptions" track-by="name" label="name"
                    :close-on-select="false" :showNoOptions="false">
                    <template slot="option" slot-scope="props">
                      <div>
                        <span>
                          <!-- <b-icon-star @click="addToDoctorFavourites(props.option)">
                        </b-icon-star> -->
                          <b-icon-star-fill @click="removeFromDoctorFavorites(props.option)"
                            variant="warning"></b-icon-star-fill>
                          <span class="pl-1" @click="addMedToPresByEan(props.option.ean, null)">{{ props.option.name
                          }}</span>
                          <span class="text-right" style="float: right"
                            @click="addMedToPresByEan(props.option.ean, null)">
                            <b-icon icon="plus-circle-fill" scale="1.4" variant="outline-primary"></b-icon>
                          </span>
                        </span>
                      </div>
                    </template>
                  </multiselect>
                  <br />
                </b-input-group>
                <!-- <h6 class="sub-head" v-if="selectedFav[selectedFav.length-1] == 'patientFav'">Patient Favourites</h6> -->
                <b-input-group size="sm" v-if="selectedFav[selectedFav.length - 1] == 'patientFav'">
                  <multiselect class="vue-multiselect" :show-labels="false" v-model="selectedPatientFav"
                    :placeholder="$t('visit.selectMedicine')" :options="patientFavOptions" track-by="ean" label="name"
                    :close-on-select="false" :showNoOptions="false">
                    <template slot="option" slot-scope="props">
                      <span>
                        <span class="text-right" style="float: right; display:inline-block; width:10%"
                          @click="addMedToPresByEan(props.option.ean, null)">
                          <b-icon icon="plus-circle-fill" scale="1.4" variant="outline-primary"
                            class="m-0 m-0"></b-icon>
                        </span>
                        <span @click="addMedToPresByEan(props.option.ean, null)" class="font-weight-bold cursor-point"
                          style="float: right; display:inline-block; width:90%">{{ props.option.name }}</span> <span
                          style="display:block;width:90%"> {{
                            props.option.issue_date | formatDate }}</span>
                      </span>
                    </template>
                  </multiselect>
                  <br />
                </b-input-group>
              </b-col>
              <b-col md="12" class="seperator-border p-1 mt-1"></b-col>
            </b-row>
            <!-- szablony recept (zestawy leków lekarza): wstawienie = reuseMedicine, dane leków zawsze aktualne z rejestru -->
            <b-row class="pb-1" align-v="center">
              <b-col md="12" class="d-flex align-items-center flex-wrap">
                <b-form-select v-model="wybranySzablon" size="sm" class="mr-2 mb-1" style="max-width: 280px"
                  :options="opcjeSzablonow" />
                <b-button size="sm" variant="outline-primary" class="mr-2 mb-1" :disabled="!wybranySzablon"
                  @click="zastosujSzablon">Wstaw szablon</b-button>
                <b-button size="sm" variant="outline-secondary" class="mr-2 mb-1"
                  :disabled="prescriptionPackages[0].medicaments.length === 0" @click="zapiszSzablon">Zapisz jako szablon</b-button>
                <b-button size="sm" variant="link" class="text-danger mb-1" :disabled="!wybranySzablon"
                  @click="usunSzablon">Usuń szablon</b-button>
                <b-button v-if="inter.wlaczone" size="sm" variant="outline-info" class="ml-auto mb-1"
                  :disabled="eanyRecepty.length < 2" @click="pokazInterakcje"
                  title="Co mówią ChPL i etykiety FDA o lekach z tej recepty (streszczenie AI z cytatami)">Interakcje — źródła</b-button>
              </b-col>
            </b-row>

            <div v-if="prescriptionPackages[0].medicaments.length === 0">
              <b-alert show variant="secondary">{{ $t('visit.presInfoText') }}</b-alert>
            </div>
            <b-overlay :show="showProgress" rounded="sm">
              <b-row class="pt-2 pb-2" v-if="prescriptionPackages[0].medicaments.length !== 0">
                <b-col md="3">
                  <b-form-group :label="$t('visit.prescription365')">
                    <b-form-checkbox v-model="prescriptionJson.is365"></b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group :label="$t('visit.rightsOptions')">
                    <b-form-select :options="rightsOptions" @change="handleRightsChange"
                      v-model="prescriptionJson.additionalRights">
                    </b-form-select>
                    <b-form-checkbox v-model="prescriptionJson.isSenior" @change="handleSeniorChange">
                      {{ $t('visit.isSenior') }} ?
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col>
                  <span>{{ $t('visit.validDateFrom') }}</span>
                  <span><b-form-datepicker size="sm" :date-format-options="{
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                    weekday: 'short'
                  }" :start-weekday="1" :min="today" v-model="prescriptionJson.dateFrom"
                      :placeholder="$t('visit.dateFrom')"></b-form-datepicker></span>
                </b-col>
                <b-col>
                  <span>{{ $t('visit.validDateTo') }}</span>
                  <span><b-form-datepicker size="sm" :date-format-options="{
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                    weekday: 'short'
                  }" :start-weekday="1" :min="today" v-model="prescriptionJson.dateTo"
                      :placeholder="$t('visit.dateTo')"></b-form-datepicker></span>
                </b-col>
                <b-col>
                  <span>{{ $t('visit.prescriptionType') }}</span>
                  <span v-if="registryPrescriptionTypes.length"><b-form-input size="sm" disabled
                      :value="registryPrescriptionTypes.join(' / ') + ' ' + $t('visit.prescriptionTypeFromRegistry')"></b-form-input></span>
                  <span v-else><b-form-select v-model="prescriptionJson.prescriptionType"
                      :options="prescriptionTypes"></b-form-select></span>
                </b-col>
                <b-col v-if="showPasswordInput">
                  <span>{{ $t('visit.certPassword') }}</span>
                  <span> <b-form-input type="password" v-model="prescriptionJson.password"></b-form-input></span>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="ml-1" v-if="prescriptionPackages[0].medicaments.length !== 0">
                  <b>Leki</b>
                </b-col>
                <b-col class="text-right  ml-1 expand-collapse-block"
                  v-if="prescriptionPackages[0].medicaments.length !== 0">
                  <span class="font-weight-bold cursor-point" v-if="!expandMed" @click="togglePres()">Expand All</span>
                  <span class="font-weight-bold cursor-point" v-if="expandMed" @click="togglePres()">Collapse All</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12" sm="12" v-for="(item, index) in this.prescriptionPackages" :key="'pres' + index"
                  class="p-0">
                  <b-card class="pres-header  p-0 m-0" v-if="item.medicaments.length != 0">
                    <b-card-header header-tag="header" class="pl-3 pt-2 pb-2" role="tab"
                      v-bind:class="(item.medicaments[0].strong) ? 'strong-med-bg' : ''">
                      <b-row align-v="center">
                        <b-col class="text-left pres-title font-weight-500">
                          {{ item.name }} | {{item.medicaments.map(m => m.medicineName).join(', ')}}
                        </b-col>
                        <b-col class="text-right pr-1">
                          <span class="text-secondary font-weight-bold pr-3">{{ item.medicaments.length }} / <span
                              v-if="!item.medicaments[0].strong">{{
                                maxMedicinePerPrescription }}</span><span
                              v-if="item.medicaments[0].strong">1</span></span>
                          <span class="text-right"
                            v-if="prescStatusList.length !== 0 && prescStatusList[index] !== undefined">
                            <b-button size="sm" v-if="!prescStatusList[index].hasError" variant="primary"
                              :disabled="!!htmlLoadingRequests[prescStatusList[index].receptyId]"
                              @click="handleViewDetails(prescStatusList[index].receptyId)"
                              class="mr-3 pl-1.1 pr-1.1 pt-0 pb-0">
                              <b-spinner small v-if="htmlLoadingRequests[prescStatusList[index].receptyId]" />
                              <font-awesome-icon v-else icon="file-prescription" />
                            </b-button>
                            <b-icon v-if="!prescStatusList[index].hasError && !prescStatusList[index].hasWarning"
                              icon="check-circle-fill" variant="success" font-scale="1.3"
                              class="mr-2 check-icon"></b-icon>
                            <b-icon v-if="!prescStatusList[index].hasError && prescStatusList[index].hasWarning"
                              icon="exclamation-triangle-fill" font-scale="1.3" variant="warning"
                              v-b-modal="'warning-modal-' + index" class="mr-2 cursor-point check-icon"></b-icon>
                            <b-modal :ref="'warning-modal-' + index" :id="'warning-modal-' + index" centered
                              :title="$t('visit.warning')"
                              v-if="!prescStatusList[index].hasError && prescStatusList[index].hasWarning">
                              <p class="my-2">{{ prescStatusList[index].userMessage }}</p>
                              <p class="mt-1 text-warning">{{ prescStatusList[index].warning }}</p>
                              <template #modal-footer>
                                <b-row>
                                  <b-col class="text-right">
                                    <b-button variant="primary"
                                      @click="$bvModal.hide('warning-modal-' + index)">{{ $t('visit.confirm') }}</b-button>
                                  </b-col>
                                </b-row>
                              </template>
                            </b-modal>
                            <b-icon v-if="prescStatusList[index].hasError === true" icon="exclamation-circle-fill"
                              font-scale="1.3" variant="danger" v-b-modal="'error-modal-' + index"
                              class="mr-2 cursor-point check-icon"></b-icon>
                            <b-modal :ref="'error-modal-' + index" :id="'error-modal-' + index" centered :title="$t('error')"
                              v-if="prescStatusList[index].hasError === true">
                              <p class="my-2">{{ prescStatusList[index].userMessage }}</p>
                              <p class="mt-1">{{ prescStatusList[index].errorDetail }}</p>
                              <template #modal-footer>
                                <b-row>
                                  <b-col class="text-right">
                                    <b-button variant="primary"
                                      @click="$bvModal.hide('error-modal-' + index)">{{ $t('visit.confirm') }}</b-button>
                                    <b-button variant="warning" class="ml-2" @click="retryPres(index)">{{ $t('visit.retry') }}</b-button>
                                  </b-col>
                                </b-row>
                              </template>
                            </b-modal>
                          </span>
                        </b-col>
                      </b-row>
                    </b-card-header>
                    <b-card-text v-bind:class="(item.medicaments[0].strong) ? 'strong-med' : ''">
                      <div class="accordion" role="tablist">
                        <b-card no-body class="pres-sub-header" v-for="(medItem, medIndex) in item.medicaments"
                          :key="'med' + medItem.ean">
                          <b-card-header header-tag="header" class="pl-3 pt-1 pb-1" role="tab">
                            <b-row>
                              <b-col md="10" class="text-left p-0" v-b-toggle="'accordion-' + index + medIndex">
                                <b-button variant="transparent" class="text-left">
                                  <span>{{ medItem.medicineName }}</span><span> -
                                    {{ opakowanie(medItem) }}</span>
                                  <span v-if="medItem.strength"> - {{ medItem.strength }}</span>
                                  <span> | {{ parsePayment(medItem) }}, {{ medItem.quantity }} paczki</span>
                                </b-button>
                              </b-col>
                              <b-col md="2" class="text-right">
                                <b-button variant="transparent" class="p-0">
                                  <b-icon icon="info-circle-fill" scale="1" variant="info" class="info mr-1"
                                    @click="showMedInfo(medItem)"></b-icon>
                                </b-button>
                                <b-button variant="transparent" class="pl-3 pr-3 p-0" @click="deleteMed(medItem)"
                                  :disabled=disableItems.disableClose>
                                  <b-icon icon="x" scale="1.2" variant="danger" class="close-icon"></b-icon>
                                </b-button>
                                <b-button v-b-toggle="'accordion-' + index + medIndex" variant="transparent"
                                  class="p-0 accor-actions">
                                  <span class="when-opened">
                                    <font-awesome-icon icon="chevron-up" />
                                  </span>
                                  <span class="when-closed">
                                    <font-awesome-icon icon="chevron-down" />
                                  </span>
                                </b-button>
                              </b-col>
                            </b-row>
                          </b-card-header>
                          <b-collapse :id="'accordion-' + index + medIndex" role="tabpanel" v-model="medItem.collapse">
                            <b-card-body>
                              <b-card-text>
                                <b-row>
                                  <b-col md="12" class="mt-0">
                                    <div class="med-name text-left mt-0">
                                      <b>{{ medItem.medicineName }}</b> -
                                      {{ medItem.manufacturer }}
                                      {{ opakowanie(medItem) }} | {{ medItem.strength }}
                                    </div>
                                    <div>
                                      <b-row v-if="!prescriptionJson.is365">
                                        <b-col md="12" class="text-left mt-0">
                                          <div class="sub-head">
                                            {{ $t('visit.quantity') }}
                                          </div>
                                        </b-col>
                                        <b-col md="12" class="mt-0 text-left">
                                          <b-form-group>
                                            <b-form-radio-group @change="OnChange(medItem)"
                                              :label="$t('visit.quantity')" v-model="medItem.quantity">
                                              <b-form-radio v-for="el in quantity" :key="'quantity' + el" :value="el"
                                                :disabled="disableItems.disableQty">{{
                                                  el
                                                }}</b-form-radio>
                                            </b-form-radio-group>
                                          </b-form-group>
                                        </b-col>
                                      </b-row>

                                      <b-row>
                                        <b-col md="12" class="text-left mt-0">
                                          <div class="sub-head">
                                            {{ $t('visit.suggestedDose') }}
                                          </div>
                                        </b-col>
                                        <b-col v-if="prescriptionJson.is365">
                                          <b-row v-for="(dosing, dosingIndex) in medItem.extendedDosage"
                                            :key="`dosing-${dosingIndex}`">
                                            <b-col cols="4">
                                              <b-form-group label="Częstotliwość: co">
                                                <b-form-input v-model.number="dosing.frequency"
                                                  type="number"></b-form-input>dni
                                              </b-form-group>
                                            </b-col>
                                            <b-col cols="2">
                                              <b-form-group label="Zakres">
                                                <b-form-input v-model.number="dosing.duration"
                                                  type="number"></b-form-input>dni
                                              </b-form-group>
                                            </b-col>
                                            <b-col cols="4">
                                              <b-form-group label="Dawkowanie w ciągu dnia">
                                                <b-form-input v-model.number="dosing.dosing"
                                                  type="number"></b-form-input>
                                              </b-form-group>
                                            </b-col>
                                          </b-row>
                                          <div v-if="medItem.kuracja && medItem.kuracja.status === 'za_dlugo'" class="text-danger small mt-1 kuracja-uwaga">
                                            {{ medItem.kuracja.komunikat }}
                                          </div>
                                          <div v-else-if="medItem.kuracja && medItem.kuracja.status === 'ok' && medItem.kuracja.opakowania"
                                            class="text-success small mt-1 kuracja-ok">
                                            ✓ {{ medItem.kuracja.opakowania }} op. · zakres {{ medItem.kuracja.dni }} dni (pełne opakowania)
                                          </div>
                                        </b-col>
                                        <b-col md="12" class="mt-0 text-left" v-else>
                                          <b-form-group>
                                            <b-form-input v-model="medItem.dose" />
                                            <div v-if="medItem.kuracja && (medItem.kuracja.status === 'dawkowanie' || medItem.kuracja.status === 'za_dlugo')"
                                              class="text-danger small mt-1 kuracja-uwaga">
                                              <span v-if="medItem.kuracja.status === 'dawkowanie'">✗ Nie rozumiem tej dawki — P1 odrzuci receptę.</span>
                                              <span v-else>{{ medItem.kuracja.komunikat }}</span>
                                              <b-button v-if="medItem.kuracja.podpowiedz" size="sm" variant="outline-primary" class="ml-2"
                                                :disabled="disableItems.disableDose" @click="wstawPodpowiedz(medItem)">
                                                Wstaw „{{ medItem.kuracja.podpowiedz.dose }}”<span v-if="medItem.kuracja.podpowiedz.data">
                                                  (recepta z {{ medItem.kuracja.podpowiedz.data }})</span>
                                              </b-button>
                                              <div v-if="medItem.kuracja.przyklady && medItem.kuracja.przyklady.length" class="mt-1 text-dark">
                                                Kliknij poprawny zapis:
                                                <b-button v-for="p in medItem.kuracja.przyklady" :key="'przyklad-' + p" size="sm"
                                                  variant="outline-secondary" class="ml-1 mt-1" :disabled="disableItems.disableDose"
                                                  @click="medItem.dose = p">{{ p }}</b-button>
                                              </div>
                                              <div v-if="medItem.kuracja.wskazowka" class="mt-1">{{ medItem.kuracja.wskazowka }}</div>
                                            </div>
                                            <div v-else-if="medItem.kuracja && medItem.kuracja.status === 'ok'" class="text-success small mt-1 kuracja-ok">
                                              ✓ <span v-if="medItem.kuracja.opis">Rozumiem: {{ medItem.kuracja.opis }} · </span>czas kuracji {{ medItem.kuracja.dni }} dni
                                            </div>
                                            <b-form-radio-group @change="OnChange(medItem)"
                                              :label="$t('visit.suggestedDose')" v-model="medItem.dose">
                                              <b-form-radio v-for="(el, index) in doses" :key="'suggestedDose' + index"
                                                :value="el" :disabled="disableItems.disableDose">{{ el
                                                }}</b-form-radio>
                                            </b-form-radio-group>
                                          </b-form-group>
                                        </b-col>
                                        <b-col md="12" class="mt-0 text-left">
                                          <b-form-group :label="$t('visit.unit')">
                                            <!-- jednostka z RPL danego opakowania (pojemność i nadopakowanie); inna psuje zgodność z P1 (31.10 Nimesil „saszetka” = 13415) -->
                                            <b-form-input v-model="medItem.unit" :list="'jednostki-' + medItem.ean" />
                                            <datalist :id="'jednostki-' + medItem.ean">
                                              <option v-for="j in jednostkiLeku(medItem)" :key="j" :value="j" />
                                            </datalist>
                                          </b-form-group>
                                        </b-col>
                                      </b-row>
                                      <b-row>
                                        <b-col md="12" class="text-left mt-0">
                                          <div class="sub-head">Taksacja</div>
                                        </b-col>
                                        <b-col md="12" class="mt-0 text-left">
                                          <b-form-group class="tax-radio">
                                            <b-form-radio-group v-model="medItem.payment">
                                              <b-form-radio @change="OnChange(medItem); medItem.odplAuto = null"
                                                :disabled="disableItems.disablePayment"
                                                v-for="(el, index) in medItem.taksacja" :key="'payment' + index"
                                                :value="getPaymentValue(el)">{{ el.refundation }}
                                                <span v-if="el.description">
                                                  - {{ el.description }}</span><span v-if="el.age">
                                                  - {{ el.age.toLowerCase() }}
                                                  {{ $t('visit.yearOld') }}</span></b-form-radio>
                                            </b-form-radio-group>
                                            <small v-if="medItem.odplAuto" :class="['d-block', medItem.odplAuto.payment ? 'text-success' : 'text-warning']">{{ opisOdplatnosci(medItem.odplAuto) }}</small>
                                            <small v-if="cenaLeku(medItem)" class="text-muted d-block">{{ cenaLeku(medItem) }}</small>
                                            <b-button v-if="!medItem.wyrob && !medItem.srodekSpozywczy" size="sm" variant="link" class="p-0"
                                              @click="pokazZamienniki(medItem)">Zamienniki</b-button>
                                          </b-form-group>
                                          <b-form-group :label="$t('visit.notReplace')">
                                            <b-form-checkbox @change="OnChange(medItem)"
                                              :disabled="disableItems.disableReplace" v-model="medItem.notReplace"
                                              :key="medItem.ean + 'notReplace'"></b-form-checkbox>
                                          </b-form-group>
                                          <!-- zał. 2 rozp. MZ (Dz.U. 2024 poz. 1600): oksykodon, morfina, fentanyl, konopie — REG.WER.16639 -->
                                          <b-form-group v-if="wymagaBadaniaOsobistego(medItem)"
                                            label="Badanie osobiste (wymagane dla tego leku)">
                                            <b-form-checkbox v-model="medItem.badanieOsobiste" @change="OnChange(medItem)"
                                              :key="medItem.ean + 'badanieOsobiste'">
                                              Pacjent zbadany przeze mnie osobiście przed wystawieniem recepty
                                            </b-form-checkbox>
                                          </b-form-group>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-card-text>
                            </b-card-body>
                          </b-collapse>
                        </b-card>
                      </div>
                    </b-card-text>
                  </b-card>
                </b-col>
              </b-row>
            </b-overlay>
          </div>
        </b-col>
        <!-- second block -->
      </b-row>
    </div>
    <!-- check side bar -->
    <!-- check side bar -->
    <template #modal-footer>
      <b-row style="width:100%">
        <b-col class="text-left">
          <b-button variant="primary" class="text-left" @click="resetForm">{{ $t('visit.resetFormBtn') }}</b-button>
        </b-col>
        <b-col class="text-right">
          <b-button variant="secondary" @click="attemptClosePrescription">{{ $t('visit.cancel') }}</b-button>
          <b-button class="ml-3" variant="primary" :disabled="disableIssuePres" @click="issuePres()">{{
            $t('visit.issuePresBtn') }}</b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
  <div v-if="prescriptionMinimized" class="prescription-progress-badge" role="button" tabindex="0"
    @click="restorePrescription" @keyup.enter="restorePrescription">
    <span class="progress-dot"></span>
    <span class="progress-text">
      <strong>{{ $t('visit.prescriptionInProgress') }}</strong>
      <span class="progress-summary">{{ minimizedSummary }}</span>
    </span>
    <b-button size="sm" variant="primary" class="restore-btn" @click.stop="restorePrescription">{{
      $t('visit.restoreBtn') }}</b-button>
  </div>
  <b-modal id="recepty-preview-modal" ref="recepty-preview-modal" :title="receptyData.title"
    dialog-class="prescription-preview-dialog">
    <center>
      <b-spinner label="Spinning" v-if="!previewLoaded"></b-spinner>
    </center>
    <div class="prescription-preview-frame">
      <iframe id="frPresPreview" v-if="previewLoaded" :src="previewSrc" type="text/html" frameborder="0"></iframe>
    </div>
    <template #modal-footer>
      <b-button variant="primary" :disabled="!!pdfLoadingRequests[receptyData.id]" @click="handleDownloadPdf(receptyData.id)">
        <b-spinner small v-if="pdfLoadingRequests[receptyData.id]" />
        <span v-else>{{ $t('visit.downloadPdfBtn') }}</span>
      </b-button>
      <b-button variant="secondary" :disabled="!!pdfLoadingRequests[receptyData.id]" @click="handlePrintPdf(receptyData.id)">
        <b-spinner small v-if="pdfLoadingRequests[receptyData.id]" />
        <span v-else>{{ $t('visit.printBtn') }}</span>
      </b-button>
      <b-button @click="$bvModal.hide('recepty-preview-modal')">{{ $t('close') }}</b-button>
    </template>
  </b-modal>
    <!-- zamienniki (odpowiedniki z RPL, dopłaty z obwieszczenia): server/src/api/medicines/zamienniki.ts -->
    <b-modal v-model="zam.pokaz" size="lg" scrollable hide-footer
      :title="'Zamienniki' + (zam.wynik ? ': ' + zam.wynik.wybrany.nazwa + ' ' + (zam.wynik.wybrany.moc || '') : '')">
      <div v-if="zam.laduje" class="text-muted">Szukam zamienników…</div>
      <div v-else-if="zam.blad" class="text-danger">{{ zam.blad }}</div>
      <div v-else-if="zam.wynik">
        <small class="text-muted d-block mb-2">Ta sama substancja, moc, postać i droga podania (Rejestr Produktów Leczniczych); dopłaty z obwieszczenia MZ<span
            v-if="zam.wynik.wybrany.doplata != null"> — wybrany: dopłata {{ zl(zam.wynik.wybrany.doplata) }} zł ({{ zam.wynik.wybrany.poziomOdplatnosci }})</span>.</small>
        <b-form-checkbox v-model="zam.inneSole" switch size="sm" class="mb-2">Pokaż też inną sól lub hydrat (sprawdź skład w ChPL)</b-form-checkbox>
        <table v-if="widoczneZamienniki.length" class="table table-sm">
          <thead><tr><th>Lek</th><th>Opakowanie</th><th>Odpł.</th><th>Dopłata</th><th>Różnica</th><th></th></tr></thead>
          <tbody>
            <tr v-for="z in widoczneZamienniki" :key="z.ean">
              <td>{{ z.nazwa }} {{ z.moc }}<br><small class="text-muted">{{ z.postac }}{{ z.podmiot ? ' · ' + z.podmiot : '' }}</small>
                <b-badge v-if="z.wskazania === 'rozne'" variant="warning" class="ml-1">inne wskazania</b-badge>
                <b-badge v-if="z.poziomZgodnosci === 3" variant="info" class="ml-1">inna sól</b-badge>
                <b-badge v-if="z.importRownolegly" variant="light" class="ml-1">import</b-badge></td>
              <td>{{ z.opis }}<small v-if="z.opakowanie === 'inne'" class="text-warning d-block">inna ilość</small></td>
              <td>{{ z.poziomOdplatnosci }}</td>
              <td>{{ z.doplata != null ? zl(z.doplata) + ' zł' : '—' }}</td>
              <td :class="z.roznica < 0 ? 'text-success' : 'text-danger'">{{ z.roznica != null && z.opakowanie === 'to samo' ? (z.roznica > 0 ? '+' : '') + zl(z.roznica) + ' zł' : '' }}</td>
              <td><b-button size="sm" variant="outline-primary" @click="zamienLek(z)">Wstaw</b-button></td>
            </tr>
          </tbody>
        </table>
        <div v-else class="text-muted">Brak zamienników w rejestrze dla tego opakowania.</div>
      </div>
    </b-modal>
    <!-- interakcje — co mówią źródła (ChPL 4.5 + FDA, streszczenie AI z cytatami): server/src/api/medicines/interakcje-zrodla.ts -->
    <b-modal v-model="inter.pokaz" size="xl" scrollable hide-footer title="Interakcje — co mówią źródła" @shown="sprawdzPrzewiniecie">
      <div v-if="inter.krok === 'zgoda'">
        <div ref="zgodaTekst" class="interakcje-zgoda small" @scroll="sprawdzPrzewiniecie">
          <p class="mb-2"><b>Zasady korzystania (wersja {{ disclaimer.wersja }}).</b> Przeczytaj do końca i potwierdź.</p>
          <p v-for="(p, i) in disclaimer.punkty" :key="i" class="mb-2"><b>{{ p.tytul }}</b> {{ p.tekst }}</p>
        </div>
        <b-form-checkbox v-model="inter.zaznaczone" :disabled="!inter.przewinieto" class="mt-2 small">{{ disclaimer.oswiadczenie }}</b-form-checkbox>
        <div class="mt-2 text-right">
          <b-button size="sm" variant="secondary" class="mr-2" @click="inter.pokaz = false">Anuluj — nie korzystam</b-button>
          <b-button size="sm" variant="primary" :disabled="!inter.zaznaczone" @click="potwierdzZgodeInterakcji">Potwierdzam</b-button>
        </div>
      </div>
      <div v-else>
        <b-alert show variant="warning" class="py-2 small mb-2">{{ disclaimer.pasek }}</b-alert>
        <div v-if="inter.laduje" class="text-muted"><b-spinner small class="mr-2" />Czytam ChPL i etykiety FDA dla leków z recepty (do minuty)…</div>
        <div v-else-if="inter.blad" class="text-danger">{{ inter.blad }}</div>
        <div v-else-if="inter.wynik">
          <div class="small text-muted mb-2">Leki: <span v-for="(l, i) in inter.wynik.leki" :key="l.ean">{{ i ? ', ' : '' }}{{ l.nazwa }} ({{ l.substancja }})</span></div>
          <div class="interakcje-odpowiedz">
            <span v-for="(o, i) in inter.wynik.odcinki" :key="i" :class="{ 'interakcje-bez-zrodla': o.bez_zrodla }">{{ o.tekst }}<sup
                v-for="(c, j) in o.cytaty" :key="j"><a href="#" :title="c.cytat" @click.prevent="inter.cytat = c">[{{ c.zrodlo + 1 }}]</a></sup><small
                v-if="o.bez_zrodla" class="text-muted" title="Zdanie modelu bez cytatu — najczęściej stwierdzenie, że dokumenty o czymś nie mówią"> (stwierdzenie AI)</small></span>
          </div>
          <b-card v-if="inter.cytat" class="mt-2" body-class="p-2">
            <small class="text-muted">Cytat ze źródła [{{ inter.cytat.zrodlo + 1 }}] {{ tytulZrodla(inter.cytat.zrodlo) }}</small>
            <blockquote class="interakcje-cytat mb-0">{{ inter.cytat.cytat }}</blockquote>
          </b-card>
          <hr class="my-2">
          <div class="small">
            <b>Źródła</b>
            <ol class="pl-3 mb-1">
              <li v-for="z in inter.wynik.zrodla" :key="z.id"><a :href="z.url" target="_blank" rel="noopener" :title="skrotyInterakcji[z.rodzaj]">{{ z.tytul }}</a><span
                  v-if="z.wersja" class="text-muted"> — wersja {{ z.wersja }}</span></li>
            </ol>
            <div class="text-muted mb-1">Skróty: <abbr :title="skrotyInterakcji.chpl">ChPL</abbr>, <abbr
                title="Rejestr Produktów Leczniczych prowadzony przez Urząd Rejestracji (URPL) — stąd polskie ChPL">RPL</abbr>, <abbr
                title="Europejska Agencja Leków — publikuje ChPL leków zarejestrowanych w całej UE">EMA</abbr>, <abbr
                :title="skrotyInterakcji.fda">FDA</abbr> (najedź, żeby zobaczyć wyjaśnienie).</div>
            <span class="text-muted">Streszczenie wygenerowane ({{ inter.wynik.model }}, {{ (inter.wynik.wygenerowano || '').slice(0, 10) }}{{ inter.wynik.z_cache ? ', z pamięci' : ', koszt ' + inter.wynik.koszt_usd + ' USD' }}). Kliknij [n], żeby zobaczyć cytowany fragment. Obowiązuje oryginał dokumentu.</span>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import interakcjeDisclaimer from './interakcje-disclaimer'
import moment from 'moment'
import medicineApi from '../../../services/medicines'
import prescriptionApi from '../../../services/prescriptionApi'
import { mapState } from 'vuex'
import VueTagsInput from '@johmun/vue-tags-input'

const MAX_365_COURSE_DAYS = 360

// import axios from 'axios
export default {
  components: {
    VueTagsInput
  },
  data() {
    return {
      szablony: [],
      wybranySzablon: null,
      zam: { pokaz: false, laduje: false, blad: '', wynik: null, lek: null, inneSole: false },
      inter: { wlaczone: false, potwierdzono: null, pokaz: false, krok: 'wynik', przewinieto: false, zaznaczone: false, laduje: false, blad: '', wynik: null, cytat: null },
      disclaimer: interakcjeDisclaimer,
      skrotyInterakcji: {
        chpl: 'ChPL — Charakterystyka Produktu Leczniczego: urzędowy opis leku dla lekarza, zatwierdzany przy rejestracji (punkt 4.5 = interakcje z innymi lekami)',
        fda: 'FDA — amerykańska Agencja Żywności i Leków; etykieta FDA (label) to amerykański odpowiednik ChPL, po angielsku (openFDA, DailyMed)'
      },
      medStateArray: [],
      medResultSuccess: false,
      expandMed: false,
      childReady: false,
      deleteMedItem: false,
      disableItems: { disableQty: false, disableDose: false, disablePayment: false, disableReplace: false, disableClose: false },
      prescStatusList: [],
      disableIssuePres: false,
      showProgress: false,
      pdfBlobCache: {},
      pdfLoadingRequests: {},
      htmlBlobCache: {},
      htmlLoadingRequests: {},
      receptyData: { title: '' },
      previewLoaded: false,
      previewSrc: null,
      prescriptionMinimized: false,
      refundedOnly: false,
      addprevMed: false,
      tag: '',
      tag1: '',
      tag2: '',
      tags: [],
      selectedFav: [],
      favOptions: [
        { text: this.$t('visit.showPatientRelated'), value: 'patientFav' },
        { text: this.$t('visit.showDoctorRelated'), value: 'doctorFav' }
      ],
      presStatus: [
        { status: null, message: '', name: 'prescription 1' },
        { status: null, message: '', name: 'prescription 2' }
      ],
      blockFullView: true,
      firstBlockSize: 0,
      secondBlockSize: 11,
      showInfo: false,
      medInfo: null,
      prescriptionJson: {
        is365: false,
        prescriptionType: 'Rp',
        dateFrom: '',
        dateTo: ''
      },
      // prescription Logic
      // prescriptionPackages: [
      //   {
      //     name: 'Prescription 1',
      //     medicaments: []
      //   },
      //   {
      //     name: 'Prescription 2',
      //     medicaments: []
      //   }
      // ],
      prescriptionPackages: [
        {
          name: this.$t('visit.presTitle') + '1',
          medicaments: []
        }
      ],
      medArray: [],
      maxPrescriptionsAllowed: 6,
      maxMedicinePerPrescription: 5,
      prescriptionCount: 0,
      count: 0,
      // prescription logic
      medicineSearchData: null,
      parsedData: [],
      prevMedicines: [],
      patientFavTags: [],
      doctorFavTags: [],
      autocompleteItems: [],
      wynikiSzukania: [],
      lekiWidoczne: {},
      otwartaGrupa: null,
      nrZapytania: 0,
      selectedQunatity: null,
      selectedApraisal: null,
      apraisalOptions: [
        { value: '100', text: '100%' },
        { value: '50', text: '50%' },
        { value: '30', text: '30%' }
      ],
      rightsOptions: [
        {
          text: 'Żadne',
          value: null
        },
        {
          'text': 'DZ: Dzieci i młodzież do ukończenia 18. roku życia (bezpłatne leki z wykazu).',
          'value': 'DZ'
        },
        {
          'text': 'C: Kobiety w ciąży i w połogu (bezpłatne leki z wykazu „Ciąża plus”).',
          'value': 'C'
        },
        {
          'text': 'ZK: Zasłużeni honorowi dawcy krwi i zasłużeni dawcy przeszczepu.',
          'value': 'ZK'
        },
        {
          'text': 'AZ: Pracownicy i byli pracownicy zakładów produkujących wyroby zawierające azbest.',
          'value': 'AZ'
        },
        {
          'text': 'IB: Inwalidzi wojenni oraz osoby represjonowane, ich małżonkowie pozostający na ich wyłącznym utrzymaniu, wdowy i wdowcy po poległych żołnierzach i zmarłych inwalidach wojennych oraz osoby represjonowane, uprawnione do renty rodzinnej, a także cywilne niewidome ofiary działań wojennych.',
          'value': 'IB'
        },
        {
          'text': 'IW: Inwalidzi wojskowi.',
          'value': 'IW'
        },
        {
          'text': 'PO: Żołnierze, którzy odbywają zasadniczą służbę wojskową, przeszkolenie wojskowe, ćwiczenia wojskowe oraz pełnią służbę kandydacką, służbę przygotowawczą lub służbę wojskową w razie ogłoszenia mobilizacji i w czasie wojny',
          'value': 'PO'
        },
        {
          'text': 'IN: Pacjenci inni niż ubezpieczeni, którzy mają prawo do bezpłatnych świadczeń opieki zdrowotnej.',
          'value': 'IN'
        },
        {
          'text': 'WP: Żołnierze zawodowi, o których mowa w przepisach ustawy o służbie wojskowej żołnierzy zawodowych, w trakcie szkoleń poligonowych i ćwiczeń wojskowych (rejsów, lotów).',
          'value': 'WP'
        }],
      selectedMedicines: [], // Must be an array reference!
      patientFavOptions: [],
      selectedPatientFav: null,
      doctorFavOptions: [],
      selectedDoctorFav: null,
      filters: {
        search: ''
      },
      prescriptionTypes: [
        {
          value: 'Rp',
          text: 'Rp'
        },
        { value: 'Rpw', text: 'Rpw' }
      ],
      doses: ['1x1', '2x1', '3x1', '1x1/2', '1x1 co 2 dni', '1x1 raz w tyg.'],
      quantity: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      loadingMedicines: false,
      medicines: [],
      fullYearPrescription: false,
      prescription: {
        medicaments: [],
        is365: false,
        prescriptionType: 'Rp',
        password: '',
        additionalRights: null
      },
      prescriptionModel: {
        medicaments: [],
        is365: false,
        prescriptionType: 'Rp',
        password: '',
        dateFrom: '',
        dateTo: '',
        additionalRights: null
      },
      withPayment: false,
      today: moment().format('YYYY-MM-DD'),
      showAllMedicaments: false,
      seniorZPesel: false
    }
  },
  watch: {
    tag: 'initItems',
    // „tylko refundowane”: filtr na pobranych wynikach; watch, bo @change checkboxa przychodzi przed aktualizacją v-model
    withPayment: 'pokazWyniki',
    // scenariusz „wiadomo”: ocena pozycji po każdej zmianie dawki, ilości, odpłatności (z opóźnieniem)
    podpisKuracji() {
      clearTimeout(this.kuracjaTimer)
      this.kuracjaTimer = setTimeout(() => this.sprawdzKuracje(), 500)
    },
    'prescriptionJson.dateTo'() {
      const diff = this.computeDurationDays()
      this.prescriptionJson.is365 = diff >= 90
      this.updateAllMedicamentsDuration()
    },
    'prescriptionJson.dateFrom'() {
      // sama data „od” nie robi recepty rocznej: bez daty „do” computeDurationDays zwraca 360 (pułapka P26)
      if (!this.prescriptionJson.dateTo) return
      const diff = this.computeDurationDays()
      this.prescriptionJson.is365 = diff >= 90
      this.updateAllMedicamentsDuration()
    },
    'patient.pesel': {
      immediate: true,
      handler(pesel) {
        this.podpowiedzUprawnienieZWieku(pesel)
      }
    },
    'prescriptionJson.is365'(newVal) {
      if (newVal) {
        if (!this.prescriptionJson.dateTo) {
          this.prescriptionJson.dateTo = moment().add(365, 'days').format('YYYY-MM-DD')
        }
        this.updateAllMedicamentsDuration()
      } else {
        this.prescriptionPackages.forEach(pkg => {
          pkg.medicaments.forEach(med => {
            med.extendedDosage = []
          })
        })
      }
    }
  },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    eanyRecepty() {
      return [...new Set(this.prescriptionPackages.flatMap((p) => p.medicaments || []).map((m) => m.ean).filter(Boolean))]
    },
    widoczneZamienniki() {
      return ((this.zam.wynik && this.zam.wynik.zamienniki) || []).filter((z) => this.zam.inneSole || z.poziomZgodnosci < 3)
    },
    opcjeSzablonow() {
      return [{ value: null, text: this.szablony.length ? 'Szablony recept…' : 'Brak szablonów recept' },
        ...this.szablony.map((s) => ({ value: s.nazwa, text: s.nazwa + ' (' + (s.leki || []).length + ')' }))]
    },
    ...mapState('Patient', {
      patient: (state) => state.patient
    }),
    podpisKuracji() {
      const pozycje = (this.prescriptionPackages || []).flatMap((p) => p.medicaments || [])
      return JSON.stringify([this.prescriptionJson.is365, pozycje.map((m) => [m.ean, m.dose, m.quantity, m.payment, m.extendedDosage])])
    },
    placeholderText: () => 'Search Medicine',
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        if (i) {
          return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
        }
      })
    },
    ...mapState('Patient', {
      patient: (state) => state.patient,
      showPasswordInput: (state) => !state.hasCertPassword
    }),
    ...mapState('Visit', {
      savedVisitId: (state) => state.savedVisitId
    }),
    filteredMedicaments() {
      return this.withPayment
        ? this.medicines.filter((el) => el.taksacja.length > 1)
        : this.medicines
    },
    isTeryt() {
      return this.patient.teryt || this.prescription.teryt
    },
    allPrescriptionMedicaments() {
      return this.prescriptionPackages.reduce((acc, pkg) => acc.concat(pkg.medicaments || []), [])
    },
    hasEnteredPrescriptionData() {
      return this.allPrescriptionMedicaments.length > 0
    },
    minimizedSummary() {
      const meds = this.allPrescriptionMedicaments
      if (meds.length === 0) return ''
      const first = meds[0]
      const parts = [first.medicineName]
      if (first.quantity) parts.push(first.quantity === 1 ? this.$t('visit.onePackage') : `${first.quantity} ${this.$t('visit.quantity')}`)
      if (first.dose) parts.push(first.dose)
      let summary = parts.filter(Boolean).join(' · ')
      if (meds.length > 1) {
        summary += ' ' + this.$t('visit.moreMedicines', { count: meds.length - 1 })
      }
      return summary
    },
    isAnyStrongMedicament() {
      return this.prescription.medicaments.some((el) => el.strong)
    },
    // recepta strong: typ recepty z rejestru dla leków silnych. Serwer podaje prescriptionTypeAuto
    // tylko przy włączonej fladze RECEPTY_STRONG_FIX — bez flagi formularz jest jak dawniej.
    registryPrescriptionTypes() {
      const leki = [].concat(...this.prescriptionPackages.map((p) => p.medicaments))
      const typy = leki.filter((m) => m.strong && m.prescriptionTypeAuto).map((m) => m.prescriptionTypeAuto)
      return Array.from(new Set(typy))
    },
    groupedMedicaments() {
      return this.filteredMedicaments.reduce(
        (prev, curr) => {
          if (curr.prio) {
            prev.priority.push(curr)
          } else {
            prev.rest.push(curr)
          }
          return prev
        },
        { priority: [], rest: [] }
      )
    }
  },
  async mounted() {
    this.wczytajSzablony()
    this.wczytajZgodeInterakcji()
    await this.getPatientFavourites()
    await this.getDoctorFavourites()
    await this.getPrevMedicines()
    this.setPrevMedicineOption()
    this.$emit('ready')
  },
  methods: {
    // scenariusz „wiadomo”: serwer ocenia każdą pozycję; wynik trafia do medItem.kuracja
    async sprawdzKuracje() {
      const pozycje = (this.prescriptionPackages || []).flatMap((p) => p.medicaments || [])
      if (pozycje.length === 0) return []
      try {
        const wynik = await prescriptionApi.checkPrescription({
          patientId: this.patient && this.patient.id,
          is365: this.prescriptionJson.is365,
          medicaments: pozycje.map((m) => ({
            ean: m.ean,
            medicineName: m.medicineName,
            dose: m.dose,
            quantity: m.quantity,
            packageSize: m.packageSize,
            unit: m.unit,
            size: m.size,
            packageKind: m.packageKind,
            payment: m.payment,
            strong: m.strong,
            extendedDosage: this.prescriptionJson.is365 ? (m.extendedDosage || []).slice(0, 1) : undefined
          }))
        })
        if (!wynik || !wynik.enabled) {
          pozycje.forEach((m) => this.$set(m, 'kuracja', null))
          return []
        }
        pozycje.forEach((m, i) => this.$set(m, 'kuracja', (wynik.items || [])[i] || null))
        // recepta roczna: zakres dopasowany przez serwer do pełnych opakowań trafia do pola „Zakres”
        if (this.prescriptionJson.is365) {
          pozycje.forEach((m) => {
            const d = (m.extendedDosage || [])[0]
            if (d && m.kuracja && m.kuracja.status === 'ok' && m.kuracja.dni && d.duration !== m.kuracja.dni) d.duration = m.kuracja.dni
          })
        }
        return pozycje.filter((m) => m.kuracja && (m.kuracja.status === 'dawkowanie' || m.kuracja.status === 'za_dlugo'))
      } catch (e) {
        return [] // ocena jest pomocą, nie strażnikiem: przy błędzie serwera wysyłka działa jak dawniej
      }
    },
    wstawPodpowiedz(medItem) {
      if (medItem.kuracja && medItem.kuracja.podpowiedz) medItem.dose = medItem.kuracja.podpowiedz.dose
    },

    // Wiek z PESEL-u (stulecie zakodowane w miesiącu); null gdy PESEL niepoprawny.
    wiekZPesel(pesel) {
      const p = String(pesel || '')
      if (!/^\d{11}$/.test(p)) return null
      const rok = Number(p.slice(0, 2))
      let mies = Number(p.slice(2, 4))
      const dzien = Number(p.slice(4, 6))
      let baza = null
      for (const [od, stulecie] of [[1, 1900], [21, 2000], [41, 2100], [61, 2200], [81, 1800]]) {
        if (mies >= od && mies <= od + 11) {
          baza = stulecie
          mies -= od - 1
        }
      }
      if (baza === null) return null
      const ur = moment({ year: baza + rok, month: mies - 1, day: dzien })
      return ur.isValid() ? moment().diff(ur, 'years') : null
    },
    // Uprawnienie z wieku: DZ do 18 lat, S od 65 lat — tylko gdy lekarz nic nie wybrał; zawsze do zmiany ręcznie.
    podpowiedzUprawnienieZWieku(pesel) {
      const wiek = this.wiekZPesel(pesel)
      if (wiek === null || !this.prescriptionJson) return
      if (this.prescriptionJson.additionalRights || this.prescriptionJson.isSenior) return
      if (wiek < 18) this.prescriptionJson.additionalRights = 'DZ'
      else if (wiek >= 65) {
        this.prescriptionJson.isSenior = true
        this.seniorZPesel = true
      }
    },
    // Zał. 2 rozp. MZ (Dz.U. 2024 poz. 1600) — ten sam wzorzec co strong-fix.ts wymagaBadaniaOsobistego (serwer pilnuje 409).
    wymagaBadaniaOsobistego(med) {
      return !!(med && med.strong) &&
        (med.activeSubstances || []).some((s) => /oxycod|oksykod|morphin|morfin|fentanyl|cannabis|konop/i.test(String((s && s.name) || '')))
    },
    computeDurationDays() {
      if (!this.prescriptionJson.dateTo) return MAX_365_COURSE_DAYS
      const from = this.prescriptionJson.dateFrom || this.today
      const duration = moment(this.prescriptionJson.dateTo).diff(moment(from), 'days')
      return this.limit365CourseDays(duration)
    },
    limit365CourseDays(duration) {
      const parsedDuration = Number(duration)
      if (!Number.isFinite(parsedDuration) || parsedDuration <= 0) {
        return MAX_365_COURSE_DAYS
      }
      return Math.min(parsedDuration, MAX_365_COURSE_DAYS)
    },
    getDefaultExtendedDosage(duration = this.computeDurationDays()) {
      return {
        frequency: 1,
        duration: this.limit365CourseDays(duration),
        dosing: 1
      }
    },
    updateAllMedicamentsDuration() {
      const duration = this.computeDurationDays()
      const is365 = this.prescriptionJson.is365
      this.prescriptionPackages.forEach(pkg => {
        pkg.medicaments.forEach(med => {
          if (is365) {
            if (med.extendedDosage && med.extendedDosage.length > 0) {
              med.extendedDosage[0].duration = duration
              med.extendedDosage = med.extendedDosage.slice(0, 1)
            } else {
              med.extendedDosage = [this.getDefaultExtendedDosage(duration)]
            }
          } else {
            med.extendedDosage = []
          }
        })
      })
    },
    handleRightsChange() {
      if (this.prescriptionJson.isSenior) {
        this.prescriptionJson.isSenior = false
      }
      return true
    },
    handleSeniorChange() {
      if (this.prescriptionJson.isSenior) {
        this.prescriptionJson.additionalRights = null // Reset when unchecked
      }
      return true
    },
    parsePayment(_medItem) {
      if (_medItem.payment.indexOf('R:') >= 0) {
        const itemInfo = _medItem.taksacja.find(itm => itm.id.toString() === _medItem.payment.split(':')[1])
        return itemInfo.refundation + '-' + itemInfo.description
      }
      return _medItem.payment
    },
    handleAddExtendedDosage(item, mainItem) {
      const newItem = {
        ...item,
        extendedDosage: [
          ...item.extendedDosage,
          this.getDefaultExtendedDosage()
        ]
      }

      this.prescriptionPackages = this.prescriptionPackages.map(el => {
        if (el.name === mainItem.name) {
          return {
            ...el,
            medicaments: el.medicaments.map(med => {
              if (med.ean === newItem.ean) {
                return newItem
              } else {
                return med
              }
            })
          }
        } else {
          return el
        }
      })

      this.OnChange(newItem)
    },

    handleRemoveDosing(item, medItem, index) {
      const newItem = {
        ...medItem,
        extendedDosage: medItem.extendedDosage.filter((el, i) => i !== index)
      }
      this.prescriptionPackages = this.prescriptionPackages.map(el => {
        if (el.name === item.name) {
          return {
            ...el,
            medicaments: el.medicaments.map(med => {
              if (med.ean === newItem.ean) {
                return newItem
              } else {
                return med
              }
            })
          }
        } else {
          return el
        }
      })

      this.OnChange(newItem)
    },
    parseMedsData(meds) {
      let perUnit = ''
      const strengths = String(meds?.strengths ?? '').split(' + ').map(s => {
        const stripped = s.split('/')[0].trim().replace('(', '').replace(')', '')
        if (s.indexOf('/') >= 1) {
          perUnit = s.split('/')[1].trim()
        }
        return stripped
      })

      const substances = String(meds?.substances ?? '').split(', ')
      const result = []
      for (let i = 0; i < substances.length; i++) {
        const composition = strengths[i] ? `${substances[i]} : ${strengths[i]}` : substances[i]
        result.push({ composition })
      }
      if (perUnit !== '') perUnit = 'per ' + perUnit
      return { comps: result, perUnit }
    },
    OnChange(item) {
      let matchedIndex = this.medStateArray.findIndex(function (medItem) {
        return (medItem.ean === item.ean)
      })
      if (matchedIndex === -1) {
        this.medStateArray.push(item)
      } else {
        this.medStateArray[matchedIndex] = item
      }
    },

    togglePres() {
      this.expandMed = !this.expandMed
      this.prescriptionPackages.forEach((item) => {
        item.medicaments.forEach((medItem) => {
          if (this.expandMed) {
            medItem['collapse'] = true
          } else {
            medItem['collapse'] = false
          }
        })
      })
    },
    resetForm() {
      this.showProgress = false
      this.prescriptionPackages = [{ name: this.$t('visit.presTitle') + '1', medicaments: [] }]
      this.medArray = []
      this.disableIssuePres = false
      this.disableItems = { disableQty: false, disableDose: false, disablePayment: false, disableReplace: false, disableClose: false }
      this.prescStatusList = []
      this.pdfBlobCache = {}
      this.pdfLoadingRequests = {}
      this.htmlBlobCache = {}
      this.htmlLoadingRequests = {}
    },
    retryPres(presIndex) {
      this.$bvModal.hide('error-modal')
      this.sendSinglePres(presIndex)
    },
    // Generic fetch-and-cache with retry/backoff, shared by the PDF and HTML
    // asset fetchers below. The cloud file is written asynchronously right
    // after submission, so an early lookup can legitimately find it missing -
    // hammering the endpoint in that window is what causes the generation to
    // be re-triggered and race/overwrite the original write. Only one fetch
    // per prescriptionId/asset is ever in flight; callers share the promise.
    prefetchAsset(cacheMap, loadingMap, prescriptionId, fetchFn, attemptsLeft, delayMs) {
      if (cacheMap[prescriptionId] || loadingMap[prescriptionId]) {
        return loadingMap[prescriptionId] || Promise.resolve(cacheMap[prescriptionId])
      }

      const attempt = async (remaining, wait) => {
        try {
          return await fetchFn()
        } catch (e) {
          if (remaining <= 1) throw e
          await new Promise((resolve) => setTimeout(resolve, wait))
          return attempt(remaining - 1, wait * 2)
        }
      }

      const promise = attempt(attemptsLeft, delayMs)
      this.$set(loadingMap, prescriptionId, promise)

      promise
        .then((result) => this.$set(cacheMap, prescriptionId, result))
        .catch(() => {})
        .finally(() => this.$delete(loadingMap, prescriptionId))

      return promise
    },
    prefetchPrescriptionPdf(prescriptionId) {
      return this.prefetchAsset(this.pdfBlobCache, this.pdfLoadingRequests, prescriptionId, async () => {
        const response = await prescriptionApi.downloadPrescription(prescriptionId)
        const blob = new Blob([response.data], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      }, 5, 2000)
    },
    // .html uploads to cloud storage well before the .pdf finishes
    // rendering, so this converges much faster - used for the instant
    // preview, while the PDF is only fetched lazily via "Download PDF".
    prefetchPrescriptionHtml(prescriptionId) {
      return this.prefetchAsset(this.htmlBlobCache, this.htmlLoadingRequests, prescriptionId, async () => {
        const response = await prescriptionApi.downloadPrescriptionHtml(prescriptionId)
        const blob = new Blob([response.data], { type: 'text/html' })
        return window.URL.createObjectURL(blob)
      }, 4, 1500)
    },
    async handleViewDetails(prescriptionId) {
      this.receptyData = {
        id: prescriptionId,
        title: 'Prescription Details - ' + prescriptionId
      }
      this.$bvModal.show('recepty-preview-modal')

      if (this.htmlBlobCache[prescriptionId]) {
        this.previewSrc = this.htmlBlobCache[prescriptionId]
        this.previewLoaded = true
        return
      }

      this.previewLoaded = false
      try {
        this.previewSrc = await this.prefetchPrescriptionHtml(prescriptionId)
        this.previewLoaded = true
      } catch (e) {
        this.$bvModal.hide('recepty-preview-modal')
        this.makeToast('danger', 'Failed to load prescription preview', 'Error')
      }
    },
    async handleDownloadPdf(prescriptionId) {
      try {
        const blobUrl = await this.prefetchPrescriptionPdf(prescriptionId)
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = `prescription_${prescriptionId}.pdf`
        link.click()
      } catch (e) {
        this.makeToast('danger', 'Failed to download prescription PDF', 'Error')
      }
    },
    async handlePrintPdf(prescriptionId) {
      try {
        const blobUrl = await this.prefetchPrescriptionPdf(prescriptionId)
        let printFrame = document.getElementById('pdf-print-frame')
        if (!printFrame) {
          printFrame = document.createElement('iframe')
          printFrame.id = 'pdf-print-frame'
          printFrame.style.display = 'none'
          document.body.appendChild(printFrame)
        }
        printFrame.onload = () => {
          printFrame.contentWindow.focus()
          printFrame.contentWindow.print()
        }
        printFrame.src = blobUrl
      } catch (e) {
        this.makeToast('danger', 'Failed to print prescription PDF', 'Error')
      }
    },
    prescriptionTypeFor(presItem) {
      const lekSilny = presItem.medicaments.find((m) => m.strong && m.prescriptionTypeAuto)
      return lekSilny ? lekSilny.prescriptionTypeAuto : this.prescriptionJson.prescriptionType
    },
    async sendSinglePres(presIndex) {
      this.showProgress = true
      let prCtr = presIndex + 1
      const presItem = this.prescriptionJson.prescriptionPackages[presIndex]
      const payload = {
        v: '2.1',
        is365: this.prescriptionJson.is365,
        additionalRights: this.prescriptionJson.isSenior === true ? 'S' : this.prescriptionJson.additionalRights,
        additionalRightsDocs: [],
        prescriptionType: this.prescriptionTypeFor(presItem),
        password: this.prescriptionJson.password,
        dateFrom: this.prescriptionJson.dateFrom,
        dateTo: this.prescriptionJson.dateTo,
        visitId: this.$route.params.visit,
        medicaments: [...presItem.medicaments],
        patientId: this.patient.id
      }
      const prescStatus = {
        hasError: false,
        hasWarning: false,
        errorDetail: '',
        warning: '',
        userMessage: ''
      }
      if (payload.medicaments.length > 0) {
        const response = await prescriptionApi.sendPrescription(
          payload,
          this.$route.params.visit
        )
        const komunikat = this.getPropFromJSONObject(response, 'komunikat')
        const presIssued = this.getPropFromJSONObject(response, 'kluczPakietuRecept')
        const verificationMessages = this.getVerificationMessages(response)
        const isWarning = verificationMessages.length > 0 && !verificationMessages.some(m => m.startsWith('❌'))
        const effectiveError = verificationMessages.join('\n') || komunikat

        if (presIssued == null) {
          prescStatus.hasError = true
          prescStatus.errorDetail = effectiveError || 'Prescription verification failed'
          prescStatus.userMessage = `Failed to issue prescription : ${prCtr}`
        } else {
          prescStatus.hasError = false
          prescStatus.hasWarning = isWarning
          prescStatus.warning = isWarning ? effectiveError : ''
          prescStatus.receptyId = this.getPropFromJSONObject(response, 'prescriptionId')
          prescStatus.userMessage = `Prescription : ${prCtr} created successfully.`
          this.getPrevMedicines()
          this.prefetchPrescriptionHtml(prescStatus.receptyId)
          this.prefetchPrescriptionPdf(prescStatus.receptyId)
        }
        this.makeToast(
          prescStatus.hasError ? 'danger' : prescStatus.hasWarning ? 'warning' : 'success',
          prescStatus.userMessage,
          'Status'
        )

        this.prescStatusList[presIndex] = prescStatus
        const errorDetails = this.prescStatusList.filter((f, idx) => idx === presIndex).map(p => p.userMessage + ' : ' + p.errorDetail + ' ').join('')
        if (prescStatus.hasError) {
          this.$swal(this.$t('error'), this.$t('visit.addPrescriptionError') + ' ' + errorDetails, 'error')
        } else if (prescStatus.hasWarning) {
          this.$swal(this.$t('success'), this.$t('visit.madeRecipeSuccess') + '\n⚠️ ' + prescStatus.warning, 'warning')
          this.prescriptionMinimized = false
          this.$emit('refresh', {})
        } else {
          this.$swal(this.$t('success'), this.$t('visit.madeRecipeSuccess'), 'success')
          this.prescriptionMinimized = false
          this.$emit('refresh', {})
        }
        this.showProgress = false
      }
    },
    changePayment(checked) {
      this.$refs.tagInput.$refs.newTagInput.focus()
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format('"dddd, MMMM Do YYYY, h:mm:ss a"')
      }
    },
    getPropFromJSONObject(jsonData, propName) {
      let str = JSON.stringify(jsonData)
      let r = new RegExp(`${propName}":"([^"]{1,})"`)
      let res = r.exec(str)
      return res && res.pop()
    },
    getVerificationMessages(jsonData) {
      const rules = []
      const visit = (node) => {
        if (Array.isArray(node)) {
          node.forEach(visit)
        } else if (node && typeof node === 'object') {
          if (Array.isArray(node.wynikWeryfikacjiReguly)) {
            rules.push(...node.wynikWeryfikacjiReguly)
          }
          Object.values(node).forEach(visit)
        }
      }
      visit(jsonData)
      const suppressedCodes = Array.isArray(jsonData.suppressedCodes) ? jsonData.suppressedCodes : ['REG.WER.14205']
      const suppressAllWarnings = jsonData.suppressAllWarnings === true
      if (suppressAllWarnings) {
        const warnings = rules.filter(r => r.wynikWeryfikacji && r.wynikWeryfikacji.includes('OSTRZEZENIE'))
        warnings.forEach(r => console.log(`[Prescription] Warning suppressed for tenant (${r.kodRegulyWeryfikacji}): ${r.opisProblemu}`))
      }
      const suppressed = rules.filter(r => suppressedCodes.includes(r.kodRegulyWeryfikacji))
      suppressed.forEach(r => console.log(`[Prescription] Warning suppressed (${r.kodRegulyWeryfikacji}): ${r.opisProblemu}`))
      return rules
        .filter(r => {
          if (!r.opisProblemu) return false
          if (suppressedCodes.includes(r.kodRegulyWeryfikacji)) return false
          if (suppressAllWarnings && r.wynikWeryfikacji && r.wynikWeryfikacji.includes('OSTRZEZENIE')) return false
          return true
        })
        .map(r => `${r.wynikWeryfikacji && r.wynikWeryfikacji.includes('OSTRZEZENIE') ? '⚠️' : '❌'} ${r.opisProblemu}`)
    },
    async changeFavourites(event) {
      let selected = event[event.length - 1]
      if (
        selected === 'patientFav' &&
        this.selectedFav.indexOf('doctorFav') !== -1
      ) {
        this.selectedFav.shift()
      } else if (
        selected === 'doctorFav' &&
        this.selectedFav.indexOf('patientFav') !== -1
      ) {
        this.selectedFav.shift()
      }
    },
    async issuePres() {
      const bezBadania = this.prescriptionPackages
        .flatMap((p) => p.medicaments)
        .filter((m) => this.wymagaBadaniaOsobistego(m) && m.badanieOsobiste !== true)
      if (bezBadania.length > 0) {
        this.makeToast('danger', bezBadania.map((m) => m.medicineName).join(', ') +
          ': zaznacz „Pacjent zbadany przeze mnie osobiście” (rozp. MZ, Dz.U. 2024 poz. 1600)', 'Recepta wymaga osobistego badania')
        return 0
      }
      this.showProgress = true
      const problemy = await this.sprawdzKuracje()
      if (problemy.length > 0) {
        this.showProgress = false
        const lista = problemy.map((m) => `${m.medicineName}: ${m.kuracja.komunikat}`).join(' ')
        this.makeToast('danger', lista, 'P1 odrzuci ten pakiet — popraw przed wysłaniem')
        return 0
      }
      if (!this.isTeryt) {
        // show message
        this.makeToast('danger', 'Invalid Teryt', 'Error!')
        return 0
      }

      this.disableItems = { disableQty: true, disableDose: true, disablePayment: true, disableReplace: true, disableClose: true }
      this.disableIssuePres = true
      this.prescriptionJson['prescriptionPackages'] = this.prescriptionPackages

      try {
        this.prescStatusList = []
        // Pakiety wysyłane RÓWNOLEGLE (P1 ~7 s na pakiet; kolejno 2 pakiety = 2 × 7 s).
        // Bezpieczeństwo: allSettled — porażka jednego pakietu nie ukrywa sukcesu innych
        // (inaczej lekarz widzi ogólny błąd i wystawia ponownie = podwójne recepty w P1).
        // Kolejność i numeracja komunikatów jak przy wysyłce kolejnej.
        const doWyslania = this.prescriptionJson.prescriptionPackages
          .map((presItem) => ({
            presItem,
            payload: {
              v: '2.1',
              is365: this.prescriptionJson.is365,
              additionalRights: this.prescriptionJson.isSenior === true ? 'S' : this.prescriptionJson.additionalRights,
              additionalRightsDocs: [],
              prescriptionType: this.prescriptionTypeFor(presItem),
              password: this.prescriptionJson.password,
              dateFrom: this.prescriptionJson.dateFrom,
              dateTo: this.prescriptionJson.dateTo,
              visitId: this.$route.params.visit,
              medicaments: [...presItem.medicaments],
              patientId: this.patient.id
            }
          }))
          .filter((p) => p.payload.medicaments.length > 0)

        const wyniki = await Promise.allSettled(
          doWyslania.map((p) => prescriptionApi.sendPrescription(p.payload, this.$route.params.visit))
        )

        wyniki.forEach((wynik, i) => {
          const prCtr = i + 1
          const prescStatus = {
            hasError: false,
            hasWarning: false,
            errorDetail: '',
            warning: '',
            userMessage: ''
          }
          if (wynik.status === 'rejected') {
            // brak odpowiedzi serwera: NIE wiadomo, czy P1 przyjął — ostrzegamy przed ponownym wystawieniem
            prescStatus.hasError = true
            prescStatus.errorDetail = 'Brak odpowiedzi serwera — nie wiadomo, czy recepta trafiła do P1. Sprawdź zakładkę Recepty, zanim wystawisz ponownie.'
            prescStatus.userMessage = `Failed to issue prescription : ${prCtr}`
          } else {
            const response = wynik.value
            const komunikat = this.getPropFromJSONObject(response, 'komunikat')
            const presIssued = this.getPropFromJSONObject(response, 'kluczPakietuRecept')
            const verificationMessages = this.getVerificationMessages(response)
            const isWarning = verificationMessages.length > 0 && !verificationMessages.some(m => m.startsWith('❌'))
            const effectiveError = verificationMessages.join('\n') || komunikat

            if (presIssued == null) {
              prescStatus.hasError = true
              prescStatus.errorDetail = effectiveError || 'Prescription verification failed'
              prescStatus.userMessage = `Failed to issue prescription : ${prCtr}`
            } else {
              prescStatus.hasError = false
              prescStatus.hasWarning = isWarning
              prescStatus.warning = isWarning ? effectiveError : ''
              prescStatus.receptyId = this.getPropFromJSONObject(response, 'prescriptionId')
              prescStatus.userMessage = `Prescription : ${prCtr} created successfully.`
              this.prefetchPrescriptionHtml(prescStatus.receptyId)
              this.prefetchPrescriptionPdf(prescStatus.receptyId)
            }
          }
          this.makeToast(
            prescStatus.hasError ? 'danger' : prescStatus.hasWarning ? 'warning' : 'success',
            prescStatus.userMessage,
            'Status'
          )
          this.prescStatusList.push(prescStatus)
        })
        if (this.prescStatusList.some((s) => !s.hasError)) this.getPrevMedicines()

        this.showProgress = false
        const hasErrors = this.prescStatusList.some(f => f.hasError === true)
        const hasWarnings = this.prescStatusList.some(f => f.hasWarning === true)
        if (hasErrors) {
          const errorDetails = this.prescStatusList.filter(f => f.hasError).map(p => p.userMessage + ' : ' + p.errorDetail + ' ').join('')
          this.$swal(this.$t('error'), this.$t('visit.addPrescriptionError') + ' ' + errorDetails, 'error')
        } else if (hasWarnings) {
          const warningDetails = this.prescStatusList.filter(f => f.hasWarning).map((p, i) => `${i + 1}. ${p.warning}`).join('\n')
          this.$swal(this.$t('success'), this.$t('visit.madeRecipeSuccess') + '\n⚠️ ' + warningDetails, 'warning')
          this.prescriptionMinimized = false
          this.$emit('refresh', {})
        } else {
          this.$swal(this.$t('success'), this.$t('visit.madeRecipeSuccess'), 'success')
          this.prescriptionMinimized = false
          this.$emit('refresh', {})
        }
      } catch (e) {
        this.$swal(
          this.$t('error'),
          this.$t('visit.addPrescriptionError'),
          'error'
        )
      } finally {
        this.showProgress = false
      }
    },
    getPresStatus(index, status, msg) {
      if (this.prescriptionPackages[index].medicaments.length !== 0) {
        this.presStatus[index].status = status
        this.presStatus[index].message = msg
      }
    },
    makeToast(variant = null, message, titleText) {
      let autoHideMilliSecs = variant === 'success' ? 2000 : 6000
      this.$bvToast.toast(message, {
        // title: `Variant ${variant || 'default'}`,
        title: titleText,
        variant: variant,
        autoHideDelay: autoHideMilliSecs,
        toaster: 'b-toaster-top-center'
      })
    },
    checkTag(obj) {

    },
    update(newTags) {
      this.autocompleteItems = []
      this.wynikiSzukania = []
      this.lekiWidoczne = {}
      this.tags = newTags
    },
    etykietaOdplatnosci(taksacja) {
      return Array.from(new Set((taksacja || []).map((k) => {
        const perc = parseFloat(k.refundation)
        return k.refundation === 'R' ? k.refundation : (perc >= 1 ? perc : perc * 100) + '%'
      }))).join(', ')
    },
    // filtr „tylko refundowane” na wynikach już pobranych — bez nowego zapytania
    pokazWyniki() {
      const leki = {}
      const naglowki = []
      for (const g of this.wynikiSzukania) {
        const lista = this.withPayment
          ? g.leki.filter((el) => Array.isArray(el.taksacja) && el.taksacja.length > 1)
          : g.leki
        if (lista.length === 0) continue
        leki[g.id] = lista
        naglowki.push({ text: g.text, id: g.id, groupType: g.groupType, n: lista.length })
      }
      this.lekiWidoczne = Object.freeze(leki)
      this.autocompleteItems = naglowki
    },
    przelaczGrupe(id) {
      this.otwartaGrupa = this.otwartaGrupa === id ? null : id
    },
    initItems() {
      if (this.tag.length < 2) return
      this.medResultSuccess = false
      clearTimeout(this.debounce)
      this.debounce = setTimeout(async () => {
        const nr = ++this.nrZapytania
        try {
          const { data } = await medicineApi.getMedicines(
            this.tag,
            this.refundedOnly
          )
          if (nr !== this.nrZapytania) return // odpowiedź na starszy tekst — nowsza już leci

          const groups = Array.isArray(data?.data?.groups) ? data.data.groups : []
          this.wynikiSzukania = Object.freeze(groups.map((a) => ({
            text: a.groupName,
            id: a.groupId,
            groupType: a.groupType,
            leki: Object.freeze((Array.isArray(a.items) ? a.items : []).map((item) => ({
              ...item,
              _ref: this.etykietaOdplatnosci(item.taksacja),
              _meds: Array.isArray(item.activeSubstances) && item.activeSubstances.length > 0
                ? this.parseMedsData({ substances: item.activeSubstances[0]?.name, strengths: item.strength })
                : { comps: [], perUnit: '' }
            })))
          })))
          this.otwartaGrupa = null
          this.pokazWyniki()
          this.medResultSuccess = true
        } catch (e) {
          // console.warn('Oh. Something went wrong')
        }
      }, 250)
    },
    includeSelectedMedToPres() {
      // this.selectedMedicines.forEach((id) => {
      //   this.addMedToPresByEan(id)
      // })

      this.addprevMed = true
      this.selectedMedicines.forEach((value) => {
        //
        // selectedItem = []
        for (var i = 0; i < this.prevMedicines.length; i++) {
          let selectedItem = this.prevMedicines[i].medicines.filter((medItem) => medItem.keyValue === value)

          if (selectedItem.length !== 0) {
            this.addMedToPresByEan(selectedItem[0].ean, { quantity: selectedItem[0].quantity, dose: selectedItem[0].dose, payment: selectedItem[0].refund })
            break
          }
        }
      })
      this.selectedMedicines = []
    },
    zl(n) {
      return Number(n).toFixed(2).replace('.', ',')
    },
    async pokazZamienniki(medItem) {
      this.zam = { pokaz: true, laduje: true, blad: '', wynik: null, lek: medItem, inneSole: false }
      try {
        const { data } = await medicineApi.getZamienniki(medItem.ean, String(medItem.payment || '').split(':')[0])
        if (data && data.wylaczone) this.zam.blad = 'Zamienniki nie są włączone w tej placówce.'
        else this.zam.wynik = data.data
      } catch (e) {
        this.zam.blad = e && e.response && e.response.status === 404 ? 'Brak danych o zamiennikach tego opakowania.' : 'Nie udało się pobrać zamienników.'
      } finally {
        this.zam.laduje = false
      }
    },
    // zamiana leku na odpowiednik: dawka i ilość zostają, odpłatność na tym samym poziomie, jeśli zamiennik go ma (inaczej 100% + ostrzeżenie)
    async zamienLek(z) {
      const stary = this.zam.lek
      try {
        const { data } = await medicineApi.getMedicineDetails(z.ean)
        const item = ((data && data.data && data.data.items) || [])[0]
        if (!item) return this.makeToast('danger', 'Nie znaleziono leku ' + z.nazwa, 'Zamienniki')
        const kod = String(stary.payment || '').split(':')[0]
        const t = (item.taksacja || []).find((x) => x.refundation === kod && x.id != null)
        this.deleteMed(stary)
        this.addprevMed = true
        this.addMedicineToPres({ ...item, quantity: stary.quantity, dose: stary.dose, payment: t ? `${t.refundation}:${t.id}` : '100%' })
        this.zam.pokaz = false
        if (kod !== '100%' && (!t || z.wskazania === 'rozne')) {
          this.makeToast('warning', t ? 'Zamiennik ma inny zakres wskazań w obwieszczeniu — sprawdź odpłatność.' : 'Zamiennik nie ma tego poziomu odpłatności — wybierz odpłatność.', 'Zamienniki')
        }
      } catch (e) {
        this.makeToast('danger', 'Nie udało się wstawić zamiennika', 'Zamienniki')
      }
    },
    async wczytajZgodeInterakcji() {
      try {
        const { data } = await medicineApi.getInterakcjeZgoda()
        this.inter.wlaczone = !!data.wlaczone
        this.inter.potwierdzono = data.potwierdzono || null
      } catch (e) {
        this.inter.wlaczone = false
      }
    },
    pokazInterakcje() {
      Object.assign(this.inter, { pokaz: true, blad: '', wynik: null, cytat: null })
      if (!this.inter.potwierdzono) {
        Object.assign(this.inter, { krok: 'zgoda', przewinieto: false, zaznaczone: false })
        return
      }
      this.inter.krok = 'wynik'
      this.pobierzInterakcje()
    },
    sprawdzPrzewiniecie() {
      const el = this.$refs.zgodaTekst
      if (el && el.scrollTop + el.clientHeight >= el.scrollHeight - 10) this.inter.przewinieto = true
    },
    async potwierdzZgodeInterakcji() {
      try {
        const { data } = await medicineApi.potwierdzInterakcjeZgoda(this.disclaimer.wersja)
        this.inter.potwierdzono = data.potwierdzono
        this.inter.krok = 'wynik'
        this.pobierzInterakcje()
      } catch (e) {
        this.inter.blad = (e && e.response && e.response.data && e.response.data.error) || 'Nie udało się zapisać potwierdzenia'
      }
    },
    async pobierzInterakcje() {
      this.inter.laduje = true
      try {
        const { data } = await medicineApi.getInterakcjeZrodla(this.eanyRecepty)
        this.inter.wynik = data.data
      } catch (e) {
        this.inter.blad = (e && e.response && e.response.data && e.response.data.error) || 'Nie udało się pobrać źródeł — spróbuj ponownie'
      } finally {
        this.inter.laduje = false
      }
    },
    tytulZrodla(id) {
      const z = this.inter.wynik && this.inter.wynik.zrodla.find((x) => x.id === id)
      return z ? '— ' + z.tytul : ''
    },
    async wczytajSzablony() {
      try {
        const { data } = await medicineApi.getSzablony()
        this.szablony = Array.isArray(data?.data?.items) ? data.data.items : []
      } catch (e) {
        this.szablony = []
      }
    },
    zastosujSzablon() {
      const s = this.szablony.find((x) => x.nazwa === this.wybranySzablon)
      if (s) this.reuseMedicine(s.leki)
    },
    async zapiszSzablon() {
      const nazwa = await this.$swal({
        title: 'Nazwa szablonu',
        text: 'Ten sam szablon pod tą nazwą zostanie zastąpiony.',
        content: { element: 'input', attributes: { value: this.wybranySzablon || '', placeholder: 'np. Cukrzyca – paski i igły' } },
        buttons: ['Anuluj', 'Zapisz']
      })
      if (!nazwa || !String(nazwa).trim()) return
      const leki = this.prescriptionPackages.flatMap((p) => p.medicaments || []).map((m) => ({
        ean: m.ean, nazwa: m.medicineName, dose: m.dose, quantity: m.quantity, refund: m.payment
      }))
      try {
        const { data } = await medicineApi.saveSzablon({ nazwa: String(nazwa).trim(), leki })
        this.szablony = data.items || this.szablony
        this.wybranySzablon = this.szablony[0] ? this.szablony[0].nazwa : null
        this.makeToast('success', 'Zapisano szablon „' + String(nazwa).trim() + '”', 'Szablony recept')
      } catch (e) {
        this.makeToast('danger', (e && e.response && e.response.data && e.response.data.error) || 'Nie udało się zapisać szablonu', 'Szablony recept')
      }
    },
    async usunSzablon() {
      const tak = await this.$swal({ title: 'Usunąć szablon „' + this.wybranySzablon + '”?', icon: 'warning', buttons: ['Anuluj', 'Usuń'], dangerMode: true })
      if (!tak) return
      try {
        const { data } = await medicineApi.deleteSzablon(this.wybranySzablon)
        this.szablony = data.items || []
        this.wybranySzablon = null
      } catch (e) {
        this.makeToast('danger', 'Nie udało się usunąć szablonu', 'Szablony recept')
      }
    },
    reuseMedicine(medicineList) {
      // medicineList.forEach((item) => {
      //   if (this.selectedMedicines.indexOf(item.ean) === -1) {
      //     this.selectedMedicines.push(item.ean)
      //   }
      // })
      // this.selectedMedicines.forEach((id) => {
      //   this.addMedToPresByEan(id)
      // })
      this.addprevMed = true
      medicineList.forEach((item) => {
        this.addMedToPresByEan(item.ean, { quantity: item.quantity, dose: item.dose, payment: item.refund })
        // this.addMedicineToPres(item)
      })
    },
    async addMedToPresByEan(id, addMedDetails) {
      try {
        const { data } = await medicineApi.getMedicineDetails(id)

        const items = Array.isArray(data?.data?.items) ? data.data.items : []
        if (items.length === 0) return
        this.addMedicineToPres(
          addMedDetails ? { ...items[0], ...addMedDetails } : items[0]
        )
      } catch (e) { }
    },
    async addToPatientFavourites(item) {
      let payload = {
        ean: item.ean,
        name: item.medicineName
      }
      try {
        await medicineApi.saveFavourites(this.patient.id, payload)
      } catch (e) { }
      this.getPatientFavourites()
    },
    async removeFromPatientFavorites(item) {
      try {
        await medicineApi.deleteFav(this.patient.id, { ean: item.ean })
      } catch (error) { }
      this.selectedPatientFav = null
      this.getPatientFavourites()
    },
    async addToDoctorFavourites(item) {
      let itemName = (item.medicineName.indexOf('mg') === -1) ? (item.medicineName + ' | ' + item.strength + ' | ' + this.opakowanie(item)) : (item.medicineName + ' | ' + this.opakowanie(item))
      // item.favourites = true
      let payload = {
        ean: item.ean,
        name: itemName
      }
      try {
        await medicineApi.saveFavourites('', payload)
        this.makeToast('success', `${item.medicineName} Added to favourites`, 'Success!')
      } catch (e) { }
      this.getDoctorFavourites()
    },
    async removeFromDoctorFavorites(item) {
      try {
        this.doctorFavOptions = this.doctorFavOptions.filter(
          (f) => f.ean !== item.ean
        )
        await medicineApi.deleteFav('', { ean: item.ean })
        this.makeToast('success', `${item.name} removed from favourites`, 'Success!')
      } catch (error) { }
      this.selectedDoctorFav = null
      this.getDoctorFavourites()
    },
    closeSuggestBox() {
      this.parsedData.items = []
      this.tags = []
    },
    closeInfo() {
      this.showInfo = false
      this.medInfo = null
    },
    showMedInfo(item) {
      this.blockFullView = false
      this.firstBlockSize = 4
      this.secondBlockSize = 8
      this.showInfo = true
      this.medInfo = {}
      setTimeout(() => {
        this.medInfo = item
      }, 10)
    },
    toggleSidebar() {
      this.blockFullView = !this.blockFullView
      if (this.blockFullView) {
        this.firstBlockSize = 0
        this.secondBlockSize = 11
      } else {
        this.firstBlockSize = 4
        this.secondBlockSize = 8
      }
    },
    minimizePrescription() {
      this.prescriptionMinimized = true
    },
    restorePrescription() {
      this.prescriptionMinimized = false
    },
    handleModalHide(bvModalEvt) {
      // Backdrop clicks never reach here (no-close-on-backdrop), and the
      // header/footer close controls call attemptClosePrescription directly
      // instead of the modal's own hide(). Esc is the one trigger that still
      // reaches here as a real user action - redirect it to "minimize"
      // instead of letting it discard the form.
      if (bvModalEvt.trigger === 'esc') {
        bvModalEvt.preventDefault()
        this.minimizePrescription()
      }
      // Any other hide (including the one bootstrap-vue fires internally when
      // our own `:visible="open && !prescriptionMinimized"` prop flips to
      // false) must be allowed to proceed - preventing it here would cancel
      // the modal's own hide and snap it back open.
    },
    attemptClosePrescription() {
      if (this.hasEnteredPrescriptionData) {
        this.$bvModal.msgBoxConfirm(this.$t('visit.closePrescriptionConfirmBody'), {
          title: this.$t('visit.closePrescriptionConfirmTitle'),
          okTitle: this.$t('visit.closePrescriptionConfirmOk'),
          cancelTitle: this.$t('visit.cancel'),
          okVariant: 'danger'
        }).then((confirmed) => {
          if (confirmed) this.discardAndClose()
        })
      } else {
        this.discardAndClose()
      }
    },
    discardAndClose() {
      this.resetForm()
      this.prescriptionMinimized = false
      this.$emit('close')
    },
    async getPatientFavourites() {
      try {
        const { data } = await medicineApi.getFavourites(this.patient.id)
        this.patientFavOptions = Array.isArray(data?.data?.items) ? data.data.items : []
      } catch (e) { }
    },
    async getDoctorFavourites() {
      try {
        const { data } = await medicineApi.getFavourites('')
        this.doctorFavOptions = Array.isArray(data?.data?.items) ? data.data.items : []
      } catch (e) { }
    },
    setPrevMedicineOption() {
      ;(Array.isArray(this.prevMedicines) ? this.prevMedicines : []).forEach((item) => {
        ;(Array.isArray(item.medicines) ? item.medicines : []).forEach((medItem) => {
          medItem['text'] = medItem.name
          medItem['value'] = medItem.keyValue
        })
      })
    },
    async getPrevMedicines() {
      try {
        const { data } = await medicineApi.getPrevMedicine(this.patient.id)
        this.prevMedicines = Array.isArray(data?.data?.items) ? data.data.items : []
      } catch (e) { }
    },
    async getMedicines(params) {
      try {
        const { data } = await medicineApi.getMedicines(params)
        this.parsedData = data?.data || []
      } catch (e) { }
    },
    formatPresciptionData() {
      this.prescriptionPackages = [{ name: this.$t('visit.presTitle') + '1', medicaments: [] }]
      this.count = 0
      // if (this.medArray.length === 2) {
      //   this.medArray[0].strong = 0
      //   this.medArray[1].strong = 1
      // }
      let strongMedicine = this.medArray.filter((item) => item.strong === 1)
      let normalMedicine = this.medArray.filter((item) => item.strong === 0)
      //
      this.formatNormalMedicine(normalMedicine)
      this.formatStrongMedicine(strongMedicine)
      // store state values
      this.medStateArray.forEach((stateItem) => {
        this.prescriptionPackages.forEach((item) => {
          item.medicaments.forEach((medItem, index) => {
            if (stateItem.ean === medItem.ean) {
              item.medicaments[index] = stateItem
            }
          })
        })
      })
      // store state values
    },
    formatStrongMedicine(strongMedicine) {
      // if (strongMedicine.length > 2) { return }
      for (let j = 0; j < strongMedicine.length; j++) {
        if (this.prescriptionPackages[this.count].medicaments.length !== 0) {
          this.count++
          this.prescriptionPackages.push({ name: this.$t('visit.presTitle') + (this.count + 1), medicaments: [] })
        }
        if (strongMedicine[j].ean === this.medArray[this.medArray.length - 1].ean) {
          strongMedicine[j]['collapse'] = true
        } else {
          strongMedicine[j]['collapse'] = false
        }
        if (this.addprevMed) {
          this.prescriptionPackages[this.count].medicaments.push(strongMedicine[j])
        } else {
          this.prescriptionPackages[this.count].medicaments.push({
            ...strongMedicine[j],
            dose: '1x1',
            quantity: '1',
            payment: '100%',
            notReplace: false,
            badanieOsobiste: false,
            extendedDosage: this.prescriptionJson.is365
              ? [this.getDefaultExtendedDosage()]
              : []
          })
          this.dobierzOdplatnosc(this.prescriptionPackages[this.count].medicaments.slice(-1)[0])
        }
        this.tag = ''
        if (strongMedicine[j].ean === this.medArray[this.medArray.length - 1].ean && !this.deleteMedItem) {
          let successMessage = 'The medicine ' + strongMedicine[j].medicineName + ' successfully added to the prescription'
          this.makeToast('success', successMessage, 'Success!')
          this.addprevMed = false
          this.deleteMedItem = false
        }
      }
      //
    },
    formatNormalMedicine(normalMedicine) {
      for (let j = 0; j < normalMedicine.length; j++) {
        if (this.prescriptionPackages[this.count].medicaments.length > this.maxMedicinePerPrescription - 1 && this.count < this.maxPrescriptionsAllowed) {
          this.count++
          this.prescriptionPackages.push({ name: this.$t('visit.presTitle') + (this.count + 1), medicaments: [] })
        }
        if (normalMedicine[j].ean === this.medArray[this.medArray.length - 1].ean) {
          normalMedicine[j]['collapse'] = true
        } else {
          normalMedicine[j]['collapse'] = false
        }
        if (this.addprevMed) {
          this.prescriptionPackages[this.count].medicaments.push(normalMedicine[j])
        } else {
          this.prescriptionPackages[this.count].medicaments.push({
            ...normalMedicine[j],
            dose: '1x1',
            quantity: '1',
            payment: '100%',
            notReplace: false,
            extendedDosage: this.prescriptionJson.is365
              ? [this.getDefaultExtendedDosage()]
              : []
          })
          this.dobierzOdplatnosc(this.prescriptionPackages[this.count].medicaments.slice(-1)[0])
        }
        this.tag = ''
        if (normalMedicine[j].ean === this.medArray[this.medArray.length - 1].ean && !this.deleteMedItem) {
          let successMessage = 'The medicine ' + normalMedicine[j].medicineName + ' successfully added to the prescription'
          this.makeToast('success', successMessage, 'Success!')
          this.deleteMedItem = false
        }
        this.addprevMed = false
      }
    },
    // odpłatność sama: jak na ostatniej recepcie pacjenta z tą substancją, inaczej z rozpoznań ICD-10 wizyty (serwer: api/medicines/odplatnosc-poprzednia.ts)
    opisOdplatnosci(o) {
      const skad = o.zrodlo === 'recepta'
        ? 'jak na recepcie z ' + o.data
        : 'przy rozpoznaniu ' + o.kod + ' wybierana w ' + o.udzial + '% recept placówki (' + o.n + ')'
      return o.payment ? 'Odpłatność ' + o.poziom + ' ' + skad + ' — sprawdź, czy wskazanie pasuje' : 'Propozycja ' + o.uwaga + ' (' + skad + ')'
    },
    async dobierzOdplatnosc(med) {
      if (!med || !this.patient || !this.patient.id || med.wyrob || med.srodekSpozywczy) return
      try {
        const { data } = await medicineApi.getOdplatnoscPoprzednia(med.ean, this.patient.id, this.$route.params.visit)
        const d = data && data.data
        if (!d || med.payment !== '100%') return // brak historii albo lekarz już wybrał
        if (d.payment) {
          med.payment = d.payment
          this.OnChange(med)
        }
        this.$set(med, 'odplAuto', d)
      } catch (e) {
        // bez podpowiedzi — formularz działa jak dotąd
      }
    },
    // cena i dopłata pacjenta z obwieszczenia MZ dla wybranej odpłatności (serwer: cenyObwieszczenia); bez danych — nic
    cenaLeku(m) {
      const ceny = m.cenyObwieszczenia || []
      if (ceny.length === 0) return ''
      const kod = String(m.payment || '').split(':')[0].trim()
      const poziom = { R: 'ryczałt', B: 'bezpłatny' }[kod] || kod
      if (kod === '100%') return `Cena w aptece (100%): ${ceny[0].cena} zł — obwieszczenie MZ`
      const w = ceny.find((c) => c.poziom.toLowerCase().startsWith(poziom.toLowerCase())) // „bezpłatny do limitu”
      return w ? `Dopłata pacjenta: ${w.doplata} zł (cena ${w.cena} zł) — obwieszczenie MZ` : `Cena: ${ceny[0].cena} zł — obwieszczenie MZ`
    },
    // opis opakowania z serwera („30 sasz. × 2 g”, „3 wstrzykiwacze × 2,4 ml”); stare pozycje bez pola — pojemność jak dotąd
    opakowanie(m) {
      return m.opisOpakowania || [m.packageSize, m.unit].filter(Boolean).join(' ')
    },
    // podpowiedzi pola „jednostka”: tylko to, co RPL mówi o tym opakowaniu (np. „g” i „sasz.” przy Nimesilu)
    jednostkiLeku(m) {
      return [...new Set([m.jednostkaRpl, m.unit, m.packageKind].map((j) => String(j || '').trim()).filter(Boolean))]
    },
    addMedicineToPres(medDetails) {
      if (this.disableIssuePres === true) {
        this.$swal(
          this.$t('error'),
          this.$t('visit.disablePresErrorMsg'),
          'error'
        )
        return
      }
      //
      let alreadyExists = this.medArray.filter(function (medItem) {
        return (medItem.ean === medDetails.ean)
      }).length > 0
      if (alreadyExists) {
        let warningMessage = medDetails.medicineName + ' already added in the prescription list'
        this.makeToast('danger', warningMessage, 'Error!')
        return
      } else {
        this.medArray.push({ ...medDetails, jednostkaRpl: medDetails.unit })
      }
      if (!medDetails && medDetails.length === 0) return
      this.formatPresciptionData()
    },
    deleteMed(medItem) {
      this.deleteMedItem = true
      let deleteIndex = this.medArray.findIndex((item) => item.ean === medItem.ean)
      let deletestateIndex = this.medStateArray.findIndex((stateItem) => stateItem.ean === this.medArray[deleteIndex].ean)
      this.medStateArray.splice(deletestateIndex, 1)
      this.medArray.splice(deleteIndex, 1)
      this.formatPresciptionData()
      let successMessage = 'The medicine ' + medItem.medicineName + ' has successfully deleted from the prescription'
      this.makeToast('danger ', successMessage, 'Success!')
    },
    async searchMedicines() {
      try {
        this.loadingMedicines = true
        this.showAllMedicaments = false
        const { data } = await medicineApi.get(this.filters)
        this.medicines = data.medicines
      } catch (e) {
      } finally {
        this.loadingMedicines = false
      }
    },
    resetData() {
      this.prescription = this.prescriptionModel
    },
    addMedicine(item) {
      this.prescription.medicaments.push({
        ...item,
        dose: '1x1',
        quantity: '1',
        payment: '100%',
        notReplace: false,
        extendedDosage: []
      })
    },
    deleteMedicine(i) {
      this.prescription.medicaments.splice(i, 1)
    },
    getDate() {
      return moment().format('YYYY-MM-DD HH:mm')
    },
    handleShowAllMedicaments() {
      this.showAllMedicaments = true
    },
    async copyPrescription(prescriptionId) {
      try {
        const data = await prescriptionApi.getPrescriptionCopy(prescriptionId)
        this.prescription = {
          ...this.prescription,
          ...data
        }
      } catch (error) {
        this.$swal(
          this.$t('error'),
          this.$t('visit.copyPrescriptionError'),
          'error'
        )
      }
    },
    sendPrescription(e) {
      try {
        if (this.isTeryt) {
          this.$emit('add', {
            ...this.prescription,
            visitId: this.$route.params.visit,
            patientId: this.patient.id
          })
          this.resetData()
        } else {
          e.preventDefault()
        }
      } catch (e) {
        this.$swal(
          this.$t('error'),
          this.$t('visit.addPrescriptionError'),
          'error'
        )
      }
    },
    getPaymentValue(payment) {
      if (payment.refundation === '100%') {
        return payment.refundation
      }
      return `${payment.refundation}:${payment.id}`
    }
  }
}
</script>
<style lang="scss">
.interakcje-zgoda { max-height: 50vh; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 4px; padding: 8px 12px; }
.interakcje-odpowiedz { white-space: pre-wrap; line-height: 1.55; }
.interakcje-bez-zrodla { color: #6c757d; font-style: italic; }
.interakcje-cytat { white-space: pre-wrap; font-size: 0.85rem; border-left: 3px solid #17a2b8; padding-left: 8px; margin-top: 4px; }
.min-width-0 {
  min-width: 0;
}

.prescription-preview-dialog {
  max-width: 420px;
}

.prescription-preview-frame {
  width: 100%;
  height: 75vh;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}

.prescription-header-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  padding-left: 0;
  flex: 0 0 auto;
  white-space: nowrap;
}

.header-action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 13px;
  cursor: pointer;
  line-height: 1.4;
}

.header-action-btn.minimize-btn {
  background-color: #d7f0ee;
  color: #146c68;
}

.header-action-btn.minimize-btn:hover {
  background-color: #c3e6e3;
}

.header-action-btn.close-btn {
  background-color: transparent;
  color: #6c757d;
  padding: 4px 8px;
}

.header-action-btn.close-btn:hover {
  background-color: #f1f1f1;
  color: #343a40;
}

.prescription-progress-badge {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1060;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 30px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  padding: 8px 12px 8px 16px;
  cursor: pointer;
  max-width: 90vw;
}

.prescription-progress-badge .progress-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #dc3545;
  flex: 0 0 auto;
  animation: prescription-progress-pulse 1.4s ease-in-out infinite;
}

.prescription-progress-badge .progress-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  overflow: hidden;
  white-space: nowrap;
}

.prescription-progress-badge .progress-summary {
  font-size: 12px;
  color: #6c757d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.prescription-progress-badge .restore-btn {
  flex: 0 0 auto;
}

@keyframes prescription-progress-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.6);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(220, 53, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
  }
}

.prescription-table td:first-child {
  min-width: 140px;
  padding-right: 10px;
}

.prescription-table td {
  padding: 5px 0px;
}

.when-closed {
  display: inline;
}

.collapsed>.when-opened,
:not(.collapsed)>.when-closed {
  display: none;
}

.accor-actions svg path {
  fill: #6c757d;
}

.accor-actions svg path:hover {
  fill: #5a6268;
}

.collapsed>.accor-opened,
:not(.collapsed)>.accor-closed {
  display: none;
}

.medicine-card {
  border: 1px solid #bbb;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 10px;
}

.taxation-list {
  list-style-type: disc;
}

.ti-tag.blue {
  background-color: blue !important;
}

.ti-tag.orange {
  background-color: orange !important;
}

.ti-tag.green {
  background-color: green !important;
}

.ti-tag.violet {
  background-color: violet !important;
}

.my-item {
  // border-bottom: 1px solid #6c757da1;
  color: #6c757d;
  padding: 0px 0px !important;
  text-align: left;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;

  .card {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}

.ti-autocomplete {
  // max-height: 300px;
  max-height: calc(100vh - 17rem);
  overflow-y: auto;
  overflow-x: hidden;
}

.my-item .card-header {
  border: none;
}

.my-item div {
  padding: 2px;
  font-size: 14px;

  .sub-text {
    font-size: 13px;
  }

  .sub-text-comp {
    color: #be7f0d;
  }
}

// .patientFav {
//   padding: 0px !important;
//   font-size: 0.9rem;
//   margin-top: 0.2rem;
// }

.action {
  padding: 10px;
  background-color: green;
  color: white;
  margin-left: 10px;
}

.my-item span {
  padding: 5px;
  margin: 5px 0px;
  font-size: 14px;
}

.ti-selected-item {
  background-color: rgb(229, 220, 220) !important;
}

.vue-tags-input {
  max-width: unset !important;
}

.sub-head {
  font-weight: bold;
  color: #495057c9;
}

.modal-title {
  width: 100%;
}

.pres-header.card {
  border: none;

  .card-body {
    padding-top: 12px;
  }
}

.suggestion-box {
  position: absolute;
  width: 93%;
  height: 100%;
  // height: 40px;
  // background-coloR: red;
  z-index: 1000;
  // background-color: #fff;

  .cont {
    background-color: #ffff;
    border: 1px solid #6c757da1;
  }
}

.tags-input {
  width: 93%;
}

.tags-auto-input {
  width: 90%;
}

.pres-header .card-header {
  background-color: #80808040;
}

.check-icon.b-icon.bi {
  vertical-align: middle;
}

.pres-sub-header .card-header {
  background-color: #6c757d17;

  .info:hover {
    fill: #067a86;
  }

  .close-icon:hover {
    fill: #c82333;
  }
}

// .strong-med,
// .strong-med-bg {
//   border: 1px solid #ffcccc !important;
// }
.pres-header .card-header.strong-med-bg {
  background-color: #ffcccc;
}

.strong-med {
  border: 2px solid #ffcccc;
  border-top: none
}

.info-box {
  position: absolute;
  height: 100%;
  width: 100%;
  height: calc(100vh - 17rem);
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;
  border: 1px solid #e2e2e2;
  z-index: 1060;
  box-shadow: 0 5px 10px rgb(0 0 0 / 0.8);
  // padding: 20px 15px;
  top: 0px;
  margin-top: 0px;
  left: 0px;
  // animation: fadeIn 10s;
}

.b-icon.bi.star-icon {
  vertical-align: text-top !important;
}

span.plus-icon,
span.minus-icon {
  display: inline-block;
  height: 17px;
  width: 17px;
  border: 1px solid gray;
  padding: 0px;
  margin: 0px;
  text-align: center;
  line-height: 12px;
  font-weight: bold;
}

.trans-first-block.col-md-0 {
  max-width: 0px;
  width: 0px;
  opacity: 0;
}

.trans-first-block.col-md-4 {
  opacity: 1;
}

.trans-container .row [class*='col-'] {
  transition: all 0.5s ease-in-out;
}

.modal-dialog-scrollable .modal-body {
  // min-height: 300px
  min-height: calc(100vh - 17rem);
}

// .b-icon {
//   cursor: pointer;
// }

.hide-block {
  opacity: 0 !important;
  transition: all 0.5s ease-in-out;
}

.info-header {
  background-color: #e9ecef;
}

.med-description {
  line-height: 1.8;
  animation: fadeIn 1s;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.modal-body {
  padding: 0px;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.content-block {
  color: #6c757d;
}

.info-box .title {
  font-weight: 500;
  color: #495057;
}

.med-actions .btn {
  padding: 5px 8px;
  outline: none;
  border: none
}

.med-actions .b-icon:hover,
.med-actions svg path:hover {
  fill: #fff;
}

.head-arrows .b-icon:hover {
  fill: #5a6268;
}

.close-icon .b-icon:hover {
  fill: #c82333;
}

.hide-info {
  display: none;
}

.show-info {
  display: block;
}

.switch-control .form-group {
  margin-bottom: auto;
}

.switch-control .custom-switch {
  font-size: 14px;
}

.modal-body {
  font-size: 14px;
}

.modal-body .btn {
  font-size: 14px;
  font-weight: 500;
}

.seperator-border {
  border-top: 1px solid lightgray;
}

.custom-check .custom-control-label {
  vertical-align: text-bottom;
  font-size: 0.9rem;
  align-items: left;
  margin-left: 0;
  font-weight: normal;
}

.med-info {
  vertical-align: text-top;
}

.pres-title {
  font-weight: 500;
}

.doc-fav {
  fill: #17a2b8;
  vertical-align: revert
}

.med-row {
  border-bottom: 1px solid #eee;
}

// .med-row{
//   .b-icon:hover, .doc-fav:hover{
//      fill: #fff;
//   }
//   .btn:hover{
//     color:white;
//   }
// }
.med-row:hover {
  background-color: #089bab;

  .b-icon:not(.star-icon) {
    fill: white
  }

  .btn {
    border: none;
  }

  span {
    color: #fff;
  }

  svg path {
    fill: #fff;
  }

  .doc-fav {
    fill: #fff !important;
  }

  .custom-icon {
    background-color: #fff;
    color: #089bab;
  }

  .custom-icon.star {
    color: #ffc107;
  }
}

.cursor-point {
  cursor: pointer;
}

.head-container,
.trans-container {
  font-size: 14px;
}

.ti-new-tag-input-wrapper {
  font-size: 14px !important;
}

.ti-new-tag-input-wrapper input {
  font-size: 14px !important;
}

.tax-radio {
  .custom-control-inline {
    display: block;
  }
}

.custom-icon {
  padding: 0px !important;
  display: inline-block;
  width: 22px;
  height: 22px;
  background-color: #089bab;
  color: #fff;
  border-radius: 50%;
  font-weight: 500;
  margin: 7px !important;
}

.custom-icon.star {
  color: #ffc107;
}

.custom-icon:hover {
  background-color: #d6d8db !important;
  color: #089bab !important;
}

.custom-icon.star:hover {
  color: #ffc107 !important;
}

.vue-multiselect {
  .multiselect__option--selected.multiselect__option--highlight {
    background: #089bab !important;
  }

  .multiselect__option--selected.multiselect__option--highlight::after {
    background: #089bab !important;
  }

  .multiselect__option--selected {
    font-weight: normal;
  }

  .multiselect__option {
    font-size: 14px;
    line-height: 18px;
  }

  .multiselect,
  .multiselect__input,
  .multiselect__single {
    font-size: 14px;
  }
}

.med-search-header {
  position: sticky;
  top: 0px;
  background-color: #f4f2f2 !important;
  z-index: 1;
  border-bottom: 1px solid #adb5bd;
}

.type2 {
  background-color: #d6d8db !important;
}

.expand-collapse-block:hover {
  color: #17a2b8 !important
}

.circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  box-shadow: 0px 0px 1px 1px #0000001a;
  position: absolute;
  top: 20px;
  right: 22px;
}

.pulse {
  animation: pulse-animation 2s infinite;
}

@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
  }

  100% {
    box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
  }
}

.green {
  background: #66FF99;
}

.orange {
  background: #f17c57fa;
}
</style>
